
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("4XbfY", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $iDrrr = parcelRequire("iDrrr");


var $8OOZ2 = parcelRequire("8OOZ2");


var $04Oo7 = parcelRequire("04Oo7");

var $chuMh = parcelRequire("chuMh");

var $ixHGM = parcelRequire("ixHGM");

var $hVgcP = parcelRequire("hVgcP");

var $6OV8L = parcelRequire("6OV8L");

var $39Puj = parcelRequire("39Puj");


var $834hU = parcelRequire("834hU");


var $2Vlq9 = parcelRequire("2Vlq9");


var $7PeFT = parcelRequire("7PeFT");





var $2kGqi = parcelRequire("2kGqi");

const $c1823554174253d2$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'panel_c1',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'fontSize',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $c1823554174253d2$export$e4e3ac1fa64862db = $c1823554174253d2$var$getDefaultSchemaConfig();
const $c1823554174253d2$export$fd147e7d448dea03 = (0, $dOBRD.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(stage = 'final')=>{
    const defaultSchemaConfig = $c1823554174253d2$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $6OV8L.layoutSectionWithSingleColumn),
        extension: (0, $iDrrr.fg)('cc_maui_annotations_on_extensions') ? (0, $hVgcP.extensionRootOnlyWithAnnotationStage0) : (0, $hVgcP.extensionRootOnlyStage0),
        bodiedExtension: (0, $04Oo7.bodiedExtensionRootOnlyStage0),
        multiBodiedExtension: (0, $ixHGM.multiBodiedExtensionRootOnlyStage0),
        extensionFrame: (0, $ixHGM.extensionFrame),
        expand: (0, $chuMh.expandWithNestedExpand),
        table: (0, $39Puj.tableWithNestedTable),
        tableRow: (0, $39Puj.tableRowWithNestedTable),
        tableCell: (0, $39Puj.tableCellWithNestedTableStage0),
        tableHeader: (0, $39Puj.tableHeaderWithNestedTableStage0),
        panel: (0, $7PeFT.extendedPanelRootOnlyStage0)(true),
        panel_c1: (0, $2Vlq9.extendedPanelC1RootOnlyStage0)(true),
        rule: (0, $2kGqi.ruleWithAttrsRootOnlyStage0),
        bodiedRule: (0, $834hU.bodiedRuleRootOnlyStage0)
    };
    return (0, $8OOZ2.createSchema)(defaultSchemaConfig);
});
const $c1823554174253d2$export$1db618b7b2275ea1 = $c1823554174253d2$export$fd147e7d448dea03();
module.exports["defaultSchemaConfig"] = $c1823554174253d2$export$e4e3ac1fa64862db;
module.exports["getSchemaBasedOnStage"] = $c1823554174253d2$export$fd147e7d448dea03;
module.exports["defaultSchema"] = $c1823554174253d2$export$1db618b7b2275ea1;

});

parcelRegister("8OOZ2", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $aPdNQ = parcelRequire("aPdNQ");

function $08922c1eccd26e1b$export$efa5595d3b524179(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
	 * Add built-in Node / Mark specs
	 */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
	 * Add Custom Node / Mark specs
	 */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $604248bd3081612c$export$4498a6080fed604c = 'fontStyle';
const $604248bd3081612c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $604248bd3081612c$export$b395009ca7f092c7 = 'link';
const $604248bd3081612c$export$9b982809044276a6 = 'color';
const $604248bd3081612c$export$470d0905851e47a1 = 'alignment';
const $604248bd3081612c$export$bacb7f4b06a06b22 = 'indentation';


// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
function $decab1b72ef42375$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $decab1b72ef42375$export$78b27f3e8d09085f = [
    $decab1b72ef42375$var$groupDeclaration((0, $604248bd3081612c$export$9b982809044276a6)),
    $decab1b72ef42375$var$groupDeclaration((0, $604248bd3081612c$export$4498a6080fed604c)),
    $decab1b72ef42375$var$groupDeclaration((0, $604248bd3081612c$export$f8e8a5f34f6ea725)),
    $decab1b72ef42375$var$groupDeclaration((0, $604248bd3081612c$export$b395009ca7f092c7))
];
const $decab1b72ef42375$export$ee0d2ba599b1121f = $decab1b72ef42375$export$78b27f3e8d09085f.map((groupMark)=>groupMark.name);




var $luPs0 = parcelRequire("luPs0");

var $epbW8 = parcelRequire("epbW8");

var $1ptyh = parcelRequire("1ptyh");

var $dWeA1 = parcelRequire("dWeA1");

var $acWDI = parcelRequire("acWDI");

var $bwEl8 = parcelRequire("bwEl8");

var $1yopN = parcelRequire("1yopN");

var $kHCzj = parcelRequire("kHCzj");

var $6nekq = parcelRequire("6nekq");

var $4Fod8 = parcelRequire("4Fod8");

var $hwsSH = parcelRequire("hwsSH");

var $7toP7 = parcelRequire("7toP7");

var $3uRAA = parcelRequire("3uRAA");

var $fyiBi = parcelRequire("fyiBi");

var $fa9Se = parcelRequire("fa9Se");

var $lhe5G = parcelRequire("lhe5G");

var $jj5Xg = parcelRequire("jj5Xg");

var $koZsE = parcelRequire("koZsE");

var $cI9Wu = parcelRequire("cI9Wu");

var $bliHm = parcelRequire("bliHm");

var $jZlhw = parcelRequire("jZlhw");

const $fe4f5a4be61de7e3$export$2a20daddecce6807 = [
    {
        name: 'link',
        spec: (0, $3uRAA.link)
    },
    {
        name: 'em',
        spec: (0, $6nekq.em)
    },
    {
        name: 'strong',
        spec: (0, $fa9Se.strong)
    },
    {
        name: 'textColor',
        spec: (0, $jj5Xg.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $1ptyh.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $fyiBi.strike)
    },
    {
        name: 'subsup',
        spec: (0, $lhe5G.subsup)
    },
    {
        name: 'underline',
        spec: (0, $cI9Wu.underline)
    },
    {
        name: 'code',
        spec: (0, $bwEl8.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $koZsE.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $luPs0.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $epbW8.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $1yopN.confluenceInlineComment)
    },
    ...(0, $decab1b72ef42375$export$78b27f3e8d09085f),
    {
        name: 'fontSize',
        spec: (0, $4Fod8.fontSize)
    },
    {
        name: 'breakout',
        spec: (0, $acWDI.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $kHCzj.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $hwsSH.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $7toP7.indentation)
    },
    {
        name: 'border',
        spec: (0, $dWeA1.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $bliHm.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $jZlhw.unsupportedNodeAttribute)
    }
];



var $azoPw = parcelRequire("azoPw");

var $9ehdj = parcelRequire("9ehdj");

var $04Oo7 = parcelRequire("04Oo7");

var $c0Rae = parcelRequire("c0Rae");

var $9nUB4 = parcelRequire("9nUB4");

var $c94QJ = parcelRequire("c94QJ");

var $jDAs4 = parcelRequire("jDAs4");

var $9zObh = parcelRequire("9zObh");

var $g185T = parcelRequire("g185T");

var $1E9VS = parcelRequire("1E9VS");

var $eq809 = parcelRequire("eq809");

var $98Lj8 = parcelRequire("98Lj8");

var $kAzEy = parcelRequire("kAzEy");

var $5SlVI = parcelRequire("5SlVI");

var $dtmRZ = parcelRequire("dtmRZ");

var $kOOm4 = parcelRequire("kOOm4");

var $chuMh = parcelRequire("chuMh");

var $9oc8s = parcelRequire("9oc8s");

var $7XIUO = parcelRequire("7XIUO");

var $7Tmz1 = parcelRequire("7Tmz1");

var $hVgcP = parcelRequire("hVgcP");

var $ixHGM = parcelRequire("ixHGM");

var $ioLmC = parcelRequire("ioLmC");

var $3RygG = parcelRequire("3RygG");

var $234td = parcelRequire("234td");

var $dYkuB = parcelRequire("dYkuB");

var $20WsY = parcelRequire("20WsY");

var $6UUJT = parcelRequire("6UUJT");

var $6OV8L = parcelRequire("6OV8L");

var $f5nzM = parcelRequire("f5nzM");

var $2fsTz = parcelRequire("2fsTz");

var $l73oM = parcelRequire("l73oM");

var $9biYD = parcelRequire("9biYD");

var $f3bB0 = parcelRequire("f3bB0");

var $jKue6 = parcelRequire("jKue6");

var $7RQ8H = parcelRequire("7RQ8H");

var $ab7A2 = parcelRequire("ab7A2");

var $gMOVH = parcelRequire("gMOVH");

var $59uj0 = parcelRequire("59uj0");

var $2kGqi = parcelRequire("2kGqi");

var $PYwg9 = parcelRequire("PYwg9");

var $5Z7gB = parcelRequire("5Z7gB");

var $39Puj = parcelRequire("39Puj");

var $7eTEw = parcelRequire("7eTEw");

var $etdmL = parcelRequire("etdmL");

var $hXS29 = parcelRequire("hXS29");

var $egqI8 = parcelRequire("egqI8");

var $kwL1e = parcelRequire("kwL1e");


var $834hU = parcelRequire("834hU");

const $3be78f0cf91042c5$export$77d2c0ec1ddbfa6c = [
    {
        name: 'doc',
        spec: (0, $5SlVI.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $gMOVH.paragraph)
    },
    {
        name: 'text',
        spec: (0, $etdmL.text)
    },
    {
        name: 'bulletList',
        spec: (0, $9nUB4.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $ab7A2.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $f5nzM.listItem)
    },
    {
        name: 'heading',
        spec: (0, $3RygG.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $9oc8s.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $jDAs4.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $7XIUO.extendedPanel)(true)
    },
    {
        name: 'panel_c1',
        spec: (0, $7Tmz1.extendedPanelC1)(true)
    },
    {
        name: 'rule',
        spec: (0, $2kGqi.rule)
    },
    {
        name: 'bodiedRule',
        spec: (0, $834hU.bodiedRule)
    },
    {
        name: 'image',
        spec: (0, $234td.image)
    },
    {
        name: 'mention',
        spec: (0, $jKue6.mention)
    },
    {
        name: 'caption',
        spec: (0, $c94QJ.caption)
    },
    {
        name: 'media',
        spec: (0, $2fsTz.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $l73oM.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $f3bB0.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $9biYD.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $59uj0.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $6OV8L.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $6UUJT.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $ioLmC.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $kOOm4.emoji)
    },
    {
        name: 'table',
        spec: (0, $39Puj.table)
    },
    {
        name: 'tableCell',
        spec: (0, $39Puj.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $39Puj.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $39Puj.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $9zObh.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $1E9VS.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $g185T.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $kAzEy.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $98Lj8.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $7eTEw.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $9ehdj.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $9ehdj.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $eq809.date)
    },
    {
        name: 'status',
        spec: (0, $PYwg9.status)
    },
    {
        name: 'expand',
        spec: (0, $chuMh.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $7RQ8H.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $hVgcP.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $20WsY.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $04Oo7.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $ixHGM.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $ixHGM.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $dYkuB.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $azoPw.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $dtmRZ.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $5Z7gB.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $c0Rae.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $hXS29.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $egqI8.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $kwL1e.unsupportedInline)
    }
];



var $22m0b = parcelRequire("22m0b");


function $31f16925c66f14d9$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat((0, $decab1b72ef42375$export$ee0d2ba599b1121f));
    let nodes = (0, $08922c1eccd26e1b$export$efa5595d3b524179)((0, $3be78f0cf91042c5$export$77d2c0ec1ddbfa6c), nodesConfig, customNodeSpecs);
    const marks = (0, $08922c1eccd26e1b$export$efa5595d3b524179)((0, $fe4f5a4be61de7e3$export$2a20daddecce6807), marksConfig, customMarkSpecs);
    nodes = (0, $22m0b.sanitizeNodes)(nodes, marks);
    return new (0, $aPdNQ.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $31f16925c66f14d9$export$c77b6d30da5276a1 = true;
module.exports["createSchema"] = $31f16925c66f14d9$export$5f4ce795563f4211;

});

parcelRegister("aPdNQ", function(module, exports) {

var $kTWwG = parcelRequire("kTWwG");

function $7e195fc5b289c822$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $7e195fc5b289c822$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $7e195fc5b289c822$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $7e195fc5b289c822$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $7e195fc5b289c822$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $7e195fc5b289c822$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $7e195fc5b289c822$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $7e195fc5b289c822$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $7e195fc5b289c822$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $7e195fc5b289c822$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $7e195fc5b289c822$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $7e195fc5b289c822$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $7e195fc5b289c822$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $7e195fc5b289c822$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $7e195fc5b289c822$var$retIndex(0, pos);
        if (pos == this.size) return $7e195fc5b289c822$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $7e195fc5b289c822$var$retIndex(i + 1, end);
                return $7e195fc5b289c822$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $7e195fc5b289c822$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $7e195fc5b289c822$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $7e195fc5b289c822$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $7e195fc5b289c822$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $7e195fc5b289c822$export$ffb0004e005737fa.empty;
        if (nodes instanceof $7e195fc5b289c822$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $7e195fc5b289c822$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $7e195fc5b289c822$export$ffb0004e005737fa.empty = new $7e195fc5b289c822$export$ffb0004e005737fa([], 0);
const $7e195fc5b289c822$var$found = {
    index: 0,
    offset: 0
};
function $7e195fc5b289c822$var$retIndex(index, offset) {
    $7e195fc5b289c822$var$found.index = index;
    $7e195fc5b289c822$var$found.offset = offset;
    return $7e195fc5b289c822$var$found;
}
function $7e195fc5b289c822$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$7e195fc5b289c822$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$7e195fc5b289c822$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $7e195fc5b289c822$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $7e195fc5b289c822$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
        if (marks instanceof $7e195fc5b289c822$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $7e195fc5b289c822$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $7e195fc5b289c822$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $7e195fc5b289c822$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $7e195fc5b289c822$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $7e195fc5b289c822$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $7e195fc5b289c822$export$b3f2e2de3a8baa1e($7e195fc5b289c822$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $7e195fc5b289c822$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $7e195fc5b289c822$export$b3f2e2de3a8baa1e($7e195fc5b289c822$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $7e195fc5b289c822$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $7e195fc5b289c822$export$b3f2e2de3a8baa1e.empty = new $7e195fc5b289c822$export$b3f2e2de3a8baa1e($7e195fc5b289c822$export$ffb0004e005737fa.empty, 0, 0);
function $7e195fc5b289c822$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($7e195fc5b289c822$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $7e195fc5b289c822$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $7e195fc5b289c822$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $7e195fc5b289c822$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $7e195fc5b289c822$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $7e195fc5b289c822$export$6de0e778727af3f2("Inconsistent open depths");
    return $7e195fc5b289c822$var$replaceOuter($from, $to, slice, 0);
}
function $7e195fc5b289c822$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $7e195fc5b289c822$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $7e195fc5b289c822$var$close(node, $7e195fc5b289c822$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $7e195fc5b289c822$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $7e195fc5b289c822$var$prepareSliceForReplace(slice, $from);
        return $7e195fc5b289c822$var$close(node, $7e195fc5b289c822$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $7e195fc5b289c822$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $7e195fc5b289c822$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $7e195fc5b289c822$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $7e195fc5b289c822$var$checkJoin(node, $after.node(depth));
    return node;
}
function $7e195fc5b289c822$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $7e195fc5b289c822$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $7e195fc5b289c822$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$7e195fc5b289c822$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $7e195fc5b289c822$var$addNode($end.nodeBefore, target);
}
function $7e195fc5b289c822$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $7e195fc5b289c822$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $7e195fc5b289c822$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $7e195fc5b289c822$var$joinable($end, $to, depth + 1);
    let content = [];
    $7e195fc5b289c822$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $7e195fc5b289c822$var$checkJoin(openStart, openEnd);
        $7e195fc5b289c822$var$addNode($7e195fc5b289c822$var$close(openStart, $7e195fc5b289c822$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $7e195fc5b289c822$var$addNode($7e195fc5b289c822$var$close(openStart, $7e195fc5b289c822$var$replaceTwoWay($from, $start, depth + 1)), content);
        $7e195fc5b289c822$var$addRange($start, $end, depth, content);
        if (openEnd) $7e195fc5b289c822$var$addNode($7e195fc5b289c822$var$close(openEnd, $7e195fc5b289c822$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $7e195fc5b289c822$var$addRange($to, null, depth, content);
    return new $7e195fc5b289c822$export$ffb0004e005737fa(content);
}
function $7e195fc5b289c822$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $7e195fc5b289c822$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $7e195fc5b289c822$var$joinable($from, $to, depth + 1);
        $7e195fc5b289c822$var$addNode($7e195fc5b289c822$var$close(type, $7e195fc5b289c822$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $7e195fc5b289c822$var$addRange($to, null, depth, content);
    return new $7e195fc5b289c822$export$ffb0004e005737fa(content);
}
function $7e195fc5b289c822$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($7e195fc5b289c822$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $7e195fc5b289c822$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $7e195fc5b289c822$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $7e195fc5b289c822$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $7e195fc5b289c822$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $7e195fc5b289c822$var$resolveCache.set(doc, cache = new $7e195fc5b289c822$var$ResolveCache);
        let result = cache.elts[cache.i] = $7e195fc5b289c822$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $7e195fc5b289c822$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $7e195fc5b289c822$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $7e195fc5b289c822$var$resolveCacheSize = 12, $7e195fc5b289c822$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $7e195fc5b289c822$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $7e195fc5b289c822$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $7e195fc5b289c822$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $7e195fc5b289c822$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $7e195fc5b289c822$var$emptyAttrs) && $7e195fc5b289c822$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $7e195fc5b289c822$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $7e195fc5b289c822$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $7e195fc5b289c822$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $7e195fc5b289c822$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $7e195fc5b289c822$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $7e195fc5b289c822$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $7e195fc5b289c822$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $7e195fc5b289c822$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $7e195fc5b289c822$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $7e195fc5b289c822$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$7e195fc5b289c822$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $7e195fc5b289c822$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $7e195fc5b289c822$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $7e195fc5b289c822$export$ffb0004e005737fa.empty;
    }
}
$7e195fc5b289c822$export$85c928794f8d04d4.prototype.text = undefined;
class $7e195fc5b289c822$var$TextNode extends $7e195fc5b289c822$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $7e195fc5b289c822$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $7e195fc5b289c822$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $7e195fc5b289c822$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $7e195fc5b289c822$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $7e195fc5b289c822$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $7e195fc5b289c822$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $7e195fc5b289c822$export$364ed450558d7ec4.empty;
        let expr = $7e195fc5b289c822$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $7e195fc5b289c822$var$dfa($7e195fc5b289c822$var$nfa(expr));
        $7e195fc5b289c822$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $7e195fc5b289c822$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $7e195fc5b289c822$export$364ed450558d7ec4.empty = new $7e195fc5b289c822$export$364ed450558d7ec4(true);
class $7e195fc5b289c822$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $7e195fc5b289c822$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($7e195fc5b289c822$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $7e195fc5b289c822$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($7e195fc5b289c822$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $7e195fc5b289c822$var$parseExprSubscript(stream) {
    let expr = $7e195fc5b289c822$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $7e195fc5b289c822$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $7e195fc5b289c822$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $7e195fc5b289c822$var$parseExprRange(stream, expr) {
    let min = $7e195fc5b289c822$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $7e195fc5b289c822$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $7e195fc5b289c822$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $7e195fc5b289c822$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $7e195fc5b289c822$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $7e195fc5b289c822$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $7e195fc5b289c822$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $7e195fc5b289c822$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $7e195fc5b289c822$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($7e195fc5b289c822$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $7e195fc5b289c822$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($7e195fc5b289c822$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $7e195fc5b289c822$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $7e195fc5b289c822$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($7e195fc5b289c822$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $7e195fc5b289c822$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $7e195fc5b289c822$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $7e195fc5b289c822$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $7e195fc5b289c822$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $7e195fc5b289c822$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $7e195fc5b289c822$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $7e195fc5b289c822$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $7e195fc5b289c822$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $7e195fc5b289c822$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $7e195fc5b289c822$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $7e195fc5b289c822$export$ffb0004e005737fa.from(content), $7e195fc5b289c822$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $7e195fc5b289c822$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $7e195fc5b289c822$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $7e195fc5b289c822$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $7e195fc5b289c822$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($7e195fc5b289c822$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $7e195fc5b289c822$export$85c928794f8d04d4(this, attrs, content.append(after), $7e195fc5b289c822$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $7e195fc5b289c822$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $7e195fc5b289c822$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $7e195fc5b289c822$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $7e195fc5b289c822$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $7e195fc5b289c822$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $7e195fc5b289c822$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $7e195fc5b289c822$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $7e195fc5b289c822$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $7e195fc5b289c822$export$c9d15bcfc6d42044(this, $7e195fc5b289c822$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $7e195fc5b289c822$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $7e195fc5b289c822$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $7e195fc5b289c822$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $7e195fc5b289c822$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $7e195fc5b289c822$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $7e195fc5b289c822$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $7e195fc5b289c822$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $7e195fc5b289c822$var$TextNode(type, type.defaultAttrs, text, $7e195fc5b289c822$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $7e195fc5b289c822$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $7e195fc5b289c822$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $kTWwG.default).from(spec.nodes), instanceSpec.marks = (0, $kTWwG.default).from(spec.marks || {}), this.nodes = $7e195fc5b289c822$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $7e195fc5b289c822$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $7e195fc5b289c822$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $7e195fc5b289c822$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $7e195fc5b289c822$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $7e195fc5b289c822$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $7e195fc5b289c822$var$isTagRule(rule) {
    return rule.tag != null;
}
function $7e195fc5b289c822$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $7e195fc5b289c822$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $7e195fc5b289c822$var$ParseContext(this, options, false);
        context.addAll(dom, $7e195fc5b289c822$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $7e195fc5b289c822$var$ParseContext(this, options, true);
        context.addAll(dom, $7e195fc5b289c822$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $7e195fc5b289c822$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($7e195fc5b289c822$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $7e195fc5b289c822$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $7e195fc5b289c822$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $7e195fc5b289c822$export$1059c6e7d2ce5669(schema, $7e195fc5b289c822$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($7e195fc5b289c822$var$isTagRule(rule)) this.tags.push(rule);
            else if ($7e195fc5b289c822$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $7e195fc5b289c822$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $7e195fc5b289c822$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $7e195fc5b289c822$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $7e195fc5b289c822$var$OPT_PRESERVE_WS = 1, $7e195fc5b289c822$var$OPT_PRESERVE_WS_FULL = 2, $7e195fc5b289c822$var$OPT_OPEN_LEFT = 4;
function $7e195fc5b289c822$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $7e195fc5b289c822$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $7e195fc5b289c822$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $7e195fc5b289c822$var$OPT_PRESERVE_WS | $7e195fc5b289c822$var$OPT_PRESERVE_WS_FULL : base & ~$7e195fc5b289c822$var$OPT_OPEN_LEFT;
}
class $7e195fc5b289c822$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($7e195fc5b289c822$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $7e195fc5b289c822$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $7e195fc5b289c822$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($7e195fc5b289c822$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$7e195fc5b289c822$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $7e195fc5b289c822$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $7e195fc5b289c822$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $7e195fc5b289c822$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $7e195fc5b289c822$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($7e195fc5b289c822$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $7e195fc5b289c822$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $7e195fc5b289c822$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($7e195fc5b289c822$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $7e195fc5b289c822$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $7e195fc5b289c822$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $7e195fc5b289c822$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $7e195fc5b289c822$var$OPT_OPEN_LEFT;
        let applyMarks = $7e195fc5b289c822$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $7e195fc5b289c822$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $7e195fc5b289c822$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $7e195fc5b289c822$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $7e195fc5b289c822$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $7e195fc5b289c822$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $7e195fc5b289c822$var$NodeContext(topNode.type, topNode.attrs, $7e195fc5b289c822$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $7e195fc5b289c822$var$NodeContext(null, null, $7e195fc5b289c822$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $7e195fc5b289c822$var$NodeContext(parser.schema.topNodeType, null, $7e195fc5b289c822$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $7e195fc5b289c822$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $7e195fc5b289c822$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $7e195fc5b289c822$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $7e195fc5b289c822$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $7e195fc5b289c822$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $7e195fc5b289c822$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $7e195fc5b289c822$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $7e195fc5b289c822$var$renderSpec($7e195fc5b289c822$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $7e195fc5b289c822$var$renderSpec($7e195fc5b289c822$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $7e195fc5b289c822$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $7e195fc5b289c822$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $7e195fc5b289c822$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $7e195fc5b289c822$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $7e195fc5b289c822$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $7e195fc5b289c822$var$doc(options) {
    return options.document || window.document;
}
const $7e195fc5b289c822$var$suspiciousAttributeCache = new WeakMap();
function $7e195fc5b289c822$var$suspiciousAttributes(attrs) {
    let value = $7e195fc5b289c822$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $7e195fc5b289c822$var$suspiciousAttributeCache.set(attrs, value = $7e195fc5b289c822$var$suspiciousAttributesInner(attrs));
    return value;
}
function $7e195fc5b289c822$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $7e195fc5b289c822$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $7e195fc5b289c822$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $7e195fc5b289c822$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}
module.exports["Fragment"] = $7e195fc5b289c822$export$ffb0004e005737fa;
module.exports["Mark"] = $7e195fc5b289c822$export$c9d15bcfc6d42044;
module.exports["ReplaceError"] = $7e195fc5b289c822$export$6de0e778727af3f2;
module.exports["Slice"] = $7e195fc5b289c822$export$b3f2e2de3a8baa1e;
module.exports["ResolvedPos"] = $7e195fc5b289c822$export$b2a42f82e59e4b19;
module.exports["NodeRange"] = $7e195fc5b289c822$export$7bc461ceb770fb16;
module.exports["Node"] = $7e195fc5b289c822$export$85c928794f8d04d4;
module.exports["ContentMatch"] = $7e195fc5b289c822$export$364ed450558d7ec4;
module.exports["NodeType"] = $7e195fc5b289c822$export$f06e977173f1857c;
module.exports["MarkType"] = $7e195fc5b289c822$export$b6a78689043c6521;
module.exports["Schema"] = $7e195fc5b289c822$export$19342e026b58ebb7;
module.exports["DOMParser"] = $7e195fc5b289c822$export$1059c6e7d2ce5669;
module.exports["DOMSerializer"] = $7e195fc5b289c822$export$3476b78f8f5a8b72;

});

parcelRegister("kTWwG", function(module, exports) {
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $f37657c8250158ad$var$OrderedMap(content) {
    this.content = content;
}
$f37657c8250158ad$var$OrderedMap.prototype = {
    constructor: $f37657c8250158ad$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $f37657c8250158ad$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $f37657c8250158ad$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $f37657c8250158ad$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $f37657c8250158ad$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $f37657c8250158ad$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $f37657c8250158ad$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $f37657c8250158ad$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $f37657c8250158ad$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $f37657c8250158ad$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $f37657c8250158ad$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$f37657c8250158ad$var$OrderedMap.from = function(value) {
    if (value instanceof $f37657c8250158ad$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $f37657c8250158ad$var$OrderedMap(content);
};
var $f37657c8250158ad$export$2e2bcd8739ae039 = $f37657c8250158ad$var$OrderedMap;
module.exports["default"] = $f37657c8250158ad$export$2e2bcd8739ae039;

});

parcelRegister("luPs0", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $5a12cb8d876640d2$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $5a12cb8d876640d2$export$8e53000a4ec837 = (0, $hFHBb.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});
module.exports["alignmentPositionMap"] = $5a12cb8d876640d2$export$be9cf49015769bbd;
module.exports["alignment"] = $5a12cb8d876640d2$export$8e53000a4ec837;

});

parcelRegister("hFHBb", function(module, exports) {
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "afm workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $hYxDb = parcelRequire("hYxDb");

const $7ef1b2cdfcc0b909$export$8e53000a4ec837 = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $7ef1b2cdfcc0b909$export$8512c9afa7b24c3b = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $7ef1b2cdfcc0b909$export$8c5a050822fd698c = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $7ef1b2cdfcc0b909$export$1edee58a52776cd9 = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $7ef1b2cdfcc0b909$export$89015c65f1c75e3f = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $7ef1b2cdfcc0b909$export$6565f9f03506010b = (0, $hYxDb.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $7ef1b2cdfcc0b909$export$f3b72f8fc4684ecd = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $7ef1b2cdfcc0b909$export$3024f02c495408d6 = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $7ef1b2cdfcc0b909$export$c63c6f932822f543 = (0, $hYxDb.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $7ef1b2cdfcc0b909$export$85e3c3ca0c6fb93 = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        fontSize: {}
    }
});
const $7ef1b2cdfcc0b909$export$f00aeb236b6f05af = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $7ef1b2cdfcc0b909$export$480c699bd4ec0d86 = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $7ef1b2cdfcc0b909$export$9c30223ca0a664fb = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $7ef1b2cdfcc0b909$export$4899a95d70ec5056 = (0, $hYxDb.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $7ef1b2cdfcc0b909$export$59ae2c325a998f89 = (0, $hYxDb.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $7ef1b2cdfcc0b909$export$b3401ee80eb31041 = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $7ef1b2cdfcc0b909$export$32f78bffcd82ff28 = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $7ef1b2cdfcc0b909$export$20af3dabbb5538df = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $7ef1b2cdfcc0b909$export$425327af25286e5e = (0, $hYxDb.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $7ef1b2cdfcc0b909$export$30d78d5eb6719bb8 = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $7ef1b2cdfcc0b909$export$a316dc07ff5182a2 = (0, $hYxDb.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});
module.exports["alignment"] = $7ef1b2cdfcc0b909$export$8e53000a4ec837;
module.exports["annotation"] = $7ef1b2cdfcc0b909$export$8512c9afa7b24c3b;
module.exports["backgroundColor"] = $7ef1b2cdfcc0b909$export$8c5a050822fd698c;
module.exports["border"] = $7ef1b2cdfcc0b909$export$1edee58a52776cd9;
module.exports["breakout"] = $7ef1b2cdfcc0b909$export$89015c65f1c75e3f;
module.exports["code"] = $7ef1b2cdfcc0b909$export$6565f9f03506010b;
module.exports["confluenceInlineComment"] = $7ef1b2cdfcc0b909$export$f3b72f8fc4684ecd;
module.exports["dataConsumer"] = $7ef1b2cdfcc0b909$export$3024f02c495408d6;
module.exports["em"] = $7ef1b2cdfcc0b909$export$c63c6f932822f543;
module.exports["fontSize"] = $7ef1b2cdfcc0b909$export$85e3c3ca0c6fb93;
module.exports["fragment"] = $7ef1b2cdfcc0b909$export$f00aeb236b6f05af;
module.exports["indentation"] = $7ef1b2cdfcc0b909$export$480c699bd4ec0d86;
module.exports["link"] = $7ef1b2cdfcc0b909$export$9c30223ca0a664fb;
module.exports["strike"] = $7ef1b2cdfcc0b909$export$4899a95d70ec5056;
module.exports["strong"] = $7ef1b2cdfcc0b909$export$59ae2c325a998f89;
module.exports["subsup"] = $7ef1b2cdfcc0b909$export$b3401ee80eb31041;
module.exports["textColor"] = $7ef1b2cdfcc0b909$export$32f78bffcd82ff28;
module.exports["typeAheadQuery"] = $7ef1b2cdfcc0b909$export$20af3dabbb5538df;
module.exports["underline"] = $7ef1b2cdfcc0b909$export$425327af25286e5e;
module.exports["unsupportedMark"] = $7ef1b2cdfcc0b909$export$30d78d5eb6719bb8;
module.exports["unsupportedNodeAttribute"] = $7ef1b2cdfcc0b909$export$a316dc07ff5182a2;

});

parcelRegister("hYxDb", function(module, exports) {
const $48d4704069cdac06$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
module.exports["createPMMarkSpecFactory"] = $48d4704069cdac06$export$cf5823ed4e9f4c6f;

});

parcelRegister("epbW8", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

var $60ca9155c04cd171$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $60ca9155c04cd171$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $60ca9155c04cd171$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $60ca9155c04cd171$export$8512c9afa7b24c3b = (0, $hFHBb.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
        Data attributes on the DOM node are a temporary means of
        incrementally switching over to the Annotation mark. Once renderer
        provides native support for inline comments the data attributes on the
        DOM nodes will be removed.
      */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$60ca9155c04cd171$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});
module.exports["AnnotationTypes"] = $60ca9155c04cd171$export$94aa2fc69ad33d19;
module.exports["AnnotationMarkStates"] = $60ca9155c04cd171$export$4bab14797673da9f;
module.exports["buildDataAttributes"] = $60ca9155c04cd171$export$93a98caa8bc6cb07;
module.exports["annotation"] = $60ca9155c04cd171$export$8512c9afa7b24c3b;

});

parcelRegister("1ptyh", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $anBbz = parcelRequire("anBbz");


var $hFHBb = parcelRequire("hFHBb");


var $kf78l = parcelRequire("kf78l");


var $k7ntk = parcelRequire("k7ntk");


var $4jl6R = parcelRequire("4jl6R");

function $470936249e02d103$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? (0, $4jl6R.textBackgroundColorPalette)[hexColor.toUpperCase()] : undefined;
}



var $1tLuA = parcelRequire("1tLuA");


var $jj5Xg = parcelRequire("jj5Xg");

const $761381ade481848a$var$colorArrayPalette = [
    [
        (0, $kf78l.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $kf78l.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $kf78l.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $kf78l.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $kf78l.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $kf78l.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $kf78l.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
const $761381ade481848a$var$colorArrayPaletteNew = [
    [
        (0, $kf78l.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $kf78l.B75),
        'Blue'
    ],
    // token: color.background.accent.blue.subtler
    [
        (0, $kf78l.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $kf78l.G75),
        'Green'
    ],
    // token: color.background.accent.green.subtler
    [
        (0, $kf78l.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $kf78l.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $kf78l.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $kf78l.R200),
        'Red'
    ],
    // token: color.background.accent.red.subtler
    [
        (0, $kf78l.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $kf78l.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $761381ade481848a$export$14ec3f21a268e497 = new Map();
$761381ade481848a$var$colorArrayPalette.forEach(([color, label])=>$761381ade481848a$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $761381ade481848a$var$RGB_PREFIX_BG_COLOR_REGEX = /^rgb/iu;
const $761381ade481848a$export$5e11ef3de07e2b1 = new Map();
$761381ade481848a$var$colorArrayPaletteNew.forEach(([color, label])=>$761381ade481848a$export$5e11ef3de07e2b1.set(color.toLowerCase(), label));
const $761381ade481848a$var$isSupportedBackgroundColor = (hexColor)=>{
    if ($761381ade481848a$export$14ec3f21a268e497.has(hexColor)) return true;
    return (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $761381ade481848a$export$5e11ef3de07e2b1.has(hexColor);
};
const $761381ade481848a$var$getBackgroundColor = (value)=>{
    let hexColor;
    if (value.match($761381ade481848a$var$RGB_PREFIX_BG_COLOR_REGEX)) hexColor = (0, $1tLuA.rgbToHex)(value);
    else if (value[0] === '#') hexColor = value.toLowerCase();
    // else handle other colour formats
    return hexColor && $761381ade481848a$var$isSupportedBackgroundColor(hexColor) ? {
        color: hexColor
    } : false;
};
const $761381ade481848a$export$8c5a050822fd698c = (0, $hFHBb.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                if ((0, $4o0zT.isExperimentEnabled)('platform_editor_fix_table_cell_background')) return false;
                return $761381ade481848a$var$getBackgroundColor(maybeValue);
            }
        },
        {
            // the table cell and background color palettes overlap on Blue and Green, so
            // we need to exclude table cells to avoid parsing table cell background as background color
            tag: '[style]:not(td):not(th)',
            consuming: false,
            priority: 60,
            getAttrs: (maybeElement)=>{
                if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_fix_table_cell_background') || !(maybeElement instanceof HTMLElement)) return false;
                return $761381ade481848a$var$getBackgroundColor(maybeElement.style.backgroundColor);
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $761381ade481848a$var$isSupportedBackgroundColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $470936249e02d103$export$8b58ff1b36bb75e0)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $jj5Xg.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $k7ntk.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});
module.exports["backgroundColorPalette"] = $761381ade481848a$export$14ec3f21a268e497;
module.exports["backgroundColorPaletteNew"] = $761381ade481848a$export$5e11ef3de07e2b1;
module.exports["backgroundColor"] = $761381ade481848a$export$8c5a050822fd698c;

});

parcelRegister("anBbz", function(module, exports) {

var $3LF1q = parcelRequire("3LF1q");

function $bc394130536019f2$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $3LF1q.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}
module.exports["expValEqualsNoExposure"] = $bc394130536019f2$export$63eebf86443a0a61;

});

parcelRegister("kf78l", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ /**
 * We're avoding importing these colors from @atlaskit/theme since we
 * do not want to have react as a dependency of this package.
 * TODO: Refactor this once tokenization by Core team is ready
 * https://product-fabric.atlassian.net/browse/CS-908
 */ 





const $5dfbdb9f0cfb9428$export$4b84fd0e2c617bd = '#FFEBE6';
const $5dfbdb9f0cfb9428$export$b34b069eff244586 = '#FFBDAD';
const $5dfbdb9f0cfb9428$export$be802dd0d8b57f35 = '#FF8F73';
const $5dfbdb9f0cfb9428$export$8ce25cbf2e1e4328 = '#FFB8B2';
const $5dfbdb9f0cfb9428$export$60847d42f9da92a6 = '#FFD5D2';
const $5dfbdb9f0cfb9428$export$4a7404f376229999 = '#FF5630';
const $5dfbdb9f0cfb9428$export$2010d0fb4295b346 = '#DE350B';
const $5dfbdb9f0cfb9428$export$2837b5a1a71d5c02 = '#BF2600';
const $5dfbdb9f0cfb9428$export$8d9596b529bbb9cf = '#FFFAE6';
const $5dfbdb9f0cfb9428$export$41060a744ab0b7ae = '#FFF0B3';
const $5dfbdb9f0cfb9428$export$5aae31392d72caaa = '#FFC400';
const $5dfbdb9f0cfb9428$export$b9aaaa578bb08b28 = '#EFDD4E';
const $5dfbdb9f0cfb9428$export$fc857b6f8771648a = '#F8E6A0';
const $5dfbdb9f0cfb9428$export$59619663aa6500fb = '#FF991F';
const $5dfbdb9f0cfb9428$export$874739ea9e379ab6 = '#FF8B00';
const $5dfbdb9f0cfb9428$export$8d067e56aec921ba = '#B38600';
const $5dfbdb9f0cfb9428$export$880b9499608823af = '#7F5F01';
const $5dfbdb9f0cfb9428$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5dfbdb9f0cfb9428$export$69a3bf21b9686c2b = '#ABF5D1';
const $5dfbdb9f0cfb9428$export$747d86715d4175de = '#57D9A3';
const $5dfbdb9f0cfb9428$export$4ba6949317382ac4 = '#97EDC9';
const $5dfbdb9f0cfb9428$export$940e1f69e873f202 = '#36B37E';
const $5dfbdb9f0cfb9428$export$a49394138f7b8e85 = '#00875A';
const $5dfbdb9f0cfb9428$export$6fa04827ac68a4fb = '#006644';
const $5dfbdb9f0cfb9428$export$226de0355ed012f8 = '#DEEBFF';
const $5dfbdb9f0cfb9428$export$8c13c2ee36917869 = '#B3D4FF';
const $5dfbdb9f0cfb9428$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5dfbdb9f0cfb9428$export$7489d9dce51bb172 = '#ADCBFB';
const $5dfbdb9f0cfb9428$export$b3de0ae08da2ce64 = '#0052CC';
const $5dfbdb9f0cfb9428$export$a6ee3d71bc067634 = '#0747A6';
const $5dfbdb9f0cfb9428$export$f51762073d2bb381 = '#EFFFD6';
const $5dfbdb9f0cfb9428$export$f72948ef771f6f15 = '#D3F1A7';
const $5dfbdb9f0cfb9428$export$4b0a7cabffffd4f5 = '#BDE97C';
const $5dfbdb9f0cfb9428$export$b118f20869cce368 = '#6A9A23';
const $5dfbdb9f0cfb9428$export$4d2dfdfde6a26b06 = '#4C6B1F';
const $5dfbdb9f0cfb9428$export$29a4f05edc054374 = '#FFFFFF';
const $5dfbdb9f0cfb9428$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5dfbdb9f0cfb9428$export$3e51e8f1440314ba = '#EBECF0';
const $5dfbdb9f0cfb9428$export$1ce2d1575d444ceb = '#DFE1E6';
const $5dfbdb9f0cfb9428$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5dfbdb9f0cfb9428$export$c2e91cbeada39b8b = '#B3BAC5';
const $5dfbdb9f0cfb9428$export$a85cd17eb3a74576 = '#B7B9BE';
const $5dfbdb9f0cfb9428$export$eaa8c8a70ac22806 = '#97A0AF';
const $5dfbdb9f0cfb9428$export$7c87d337fb91a97d = '#8993A4';
const $5dfbdb9f0cfb9428$export$f563ee71e9ee74cd = '#6B778C';
const $5dfbdb9f0cfb9428$export$e2ef2124cf4024b1 = '#5E6C84';
const $5dfbdb9f0cfb9428$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $5dfbdb9f0cfb9428$export$13609db0e6812ab8 = '#091E4224';
const $5dfbdb9f0cfb9428$export$c39c0fe0f26207ae = '#42526E';
const $5dfbdb9f0cfb9428$export$7090862dc3038a9f = '#758195';
const $5dfbdb9f0cfb9428$export$7d61b15e0da132af = '#172B4D';
const $5dfbdb9f0cfb9428$export$f78789c8b01753cd = '#172B4D';
const $5dfbdb9f0cfb9428$export$dce26b47982a2d83 = '#FFECF8';
const $5dfbdb9f0cfb9428$export$a19f0c33186f7767 = '#FDD0EC';
const $5dfbdb9f0cfb9428$export$a1d4686c17e1cdef = '#FCB6E1';
const $5dfbdb9f0cfb9428$export$3bff0a0c68537008 = '#CD519D';
const $5dfbdb9f0cfb9428$export$aedcf6658caf5ad6 = '#943D73';
const $5dfbdb9f0cfb9428$export$51716a84e62e022c = '#FEDEC8';
const $5dfbdb9f0cfb9428$export$8692a80ca6403e1e = '#FFF5DB';
const $5dfbdb9f0cfb9428$export$a0fa9fa6bfbb29d1 = '#FCE4A6';
const $5dfbdb9f0cfb9428$export$e58d39c2a9e7b70e = '#FBD779';
const $5dfbdb9f0cfb9428$export$65becf92d294645b = '#E06C00';
const $5dfbdb9f0cfb9428$export$d50a5202329f668e = '#9E4C00';
const $5dfbdb9f0cfb9428$export$363e4475840015bb = '#EAE6FF';
const $5dfbdb9f0cfb9428$export$4b0a4417ed59760f = '#C0B6F2';
const $5dfbdb9f0cfb9428$export$6011520a64d9a187 = '#998DD9';
const $5dfbdb9f0cfb9428$export$33050b411a4844fe = '#E3BDFA';
const $5dfbdb9f0cfb9428$export$a7175d4e9206bc80 = '#DFD8FD';
const $5dfbdb9f0cfb9428$export$b48405b95304b5a1 = '#6554C0';
const $5dfbdb9f0cfb9428$export$c71e4279dd54a18d = '#5243AA';
const $5dfbdb9f0cfb9428$export$147899de772240ec = '#403294';
const $5dfbdb9f0cfb9428$export$2cf711fe14c66f06 = '#E6FCFF';
const $5dfbdb9f0cfb9428$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5dfbdb9f0cfb9428$export$776c9c497ef08533 = '#79E2F2';
const $5dfbdb9f0cfb9428$export$f4de2950886ae4c9 = '#B1E4F7';
const $5dfbdb9f0cfb9428$export$69cb3ca10c1e330e = '#C6EDFB';
const $5dfbdb9f0cfb9428$export$9dc1ef0f3f48059b = '#00B8D9';
const $5dfbdb9f0cfb9428$export$6036577f95c3877e = '#008DA6';
module.exports["R50"] = $5dfbdb9f0cfb9428$export$4b84fd0e2c617bd;
module.exports["R75"] = $5dfbdb9f0cfb9428$export$b34b069eff244586;
module.exports["R100"] = $5dfbdb9f0cfb9428$export$be802dd0d8b57f35;
module.exports["RedBold"] = $5dfbdb9f0cfb9428$export$8ce25cbf2e1e4328;
module.exports["R200"] = $5dfbdb9f0cfb9428$export$60847d42f9da92a6;
module.exports["R300"] = $5dfbdb9f0cfb9428$export$4a7404f376229999;
module.exports["R400"] = $5dfbdb9f0cfb9428$export$2010d0fb4295b346;
module.exports["R500"] = $5dfbdb9f0cfb9428$export$2837b5a1a71d5c02;
module.exports["Y50"] = $5dfbdb9f0cfb9428$export$8d9596b529bbb9cf;
module.exports["Y75"] = $5dfbdb9f0cfb9428$export$41060a744ab0b7ae;
module.exports["Y200"] = $5dfbdb9f0cfb9428$export$5aae31392d72caaa;
module.exports["YellowBold"] = $5dfbdb9f0cfb9428$export$b9aaaa578bb08b28;
module.exports["Yellow200"] = $5dfbdb9f0cfb9428$export$fc857b6f8771648a;
module.exports["Y400"] = $5dfbdb9f0cfb9428$export$59619663aa6500fb;
module.exports["Y500"] = $5dfbdb9f0cfb9428$export$874739ea9e379ab6;
module.exports["Y600"] = $5dfbdb9f0cfb9428$export$8d067e56aec921ba;
module.exports["Y800"] = $5dfbdb9f0cfb9428$export$880b9499608823af;
module.exports["G50"] = $5dfbdb9f0cfb9428$export$8a6341c32b6a3ee6;
module.exports["G75"] = $5dfbdb9f0cfb9428$export$69a3bf21b9686c2b;
module.exports["G200"] = $5dfbdb9f0cfb9428$export$747d86715d4175de;
module.exports["GreenBold"] = $5dfbdb9f0cfb9428$export$4ba6949317382ac4;
module.exports["G300"] = $5dfbdb9f0cfb9428$export$940e1f69e873f202;
module.exports["G400"] = $5dfbdb9f0cfb9428$export$a49394138f7b8e85;
module.exports["G500"] = $5dfbdb9f0cfb9428$export$6fa04827ac68a4fb;
module.exports["B50"] = $5dfbdb9f0cfb9428$export$226de0355ed012f8;
module.exports["B75"] = $5dfbdb9f0cfb9428$export$8c13c2ee36917869;
module.exports["B100"] = $5dfbdb9f0cfb9428$export$ecfc1dff386a3e7a;
module.exports["BlueBold"] = $5dfbdb9f0cfb9428$export$7489d9dce51bb172;
module.exports["B400"] = $5dfbdb9f0cfb9428$export$b3de0ae08da2ce64;
module.exports["B500"] = $5dfbdb9f0cfb9428$export$a6ee3d71bc067634;
module.exports["L50"] = $5dfbdb9f0cfb9428$export$f51762073d2bb381;
module.exports["L200"] = $5dfbdb9f0cfb9428$export$f72948ef771f6f15;
module.exports["L400"] = $5dfbdb9f0cfb9428$export$4b0a7cabffffd4f5;
module.exports["L600"] = $5dfbdb9f0cfb9428$export$b118f20869cce368;
module.exports["L800"] = $5dfbdb9f0cfb9428$export$4d2dfdfde6a26b06;
module.exports["N0"] = $5dfbdb9f0cfb9428$export$29a4f05edc054374;
module.exports["N20"] = $5dfbdb9f0cfb9428$export$9fdfb749e33cdf97;
module.exports["N30"] = $5dfbdb9f0cfb9428$export$3e51e8f1440314ba;
module.exports["N40"] = $5dfbdb9f0cfb9428$export$1ce2d1575d444ceb;
module.exports["N50"] = $5dfbdb9f0cfb9428$export$8754fc7e6d8b3000;
module.exports["N60"] = $5dfbdb9f0cfb9428$export$c2e91cbeada39b8b;
module.exports["GrayBold"] = $5dfbdb9f0cfb9428$export$a85cd17eb3a74576;
module.exports["N80"] = $5dfbdb9f0cfb9428$export$eaa8c8a70ac22806;
module.exports["N90"] = $5dfbdb9f0cfb9428$export$7c87d337fb91a97d;
module.exports["N200"] = $5dfbdb9f0cfb9428$export$f563ee71e9ee74cd;
module.exports["N300"] = $5dfbdb9f0cfb9428$export$e2ef2124cf4024b1;
module.exports["Neutral300"] = $5dfbdb9f0cfb9428$export$1ae1cebe22dcedb4;
module.exports["N300A"] = $5dfbdb9f0cfb9428$export$13609db0e6812ab8;
module.exports["N500"] = $5dfbdb9f0cfb9428$export$c39c0fe0f26207ae;
module.exports["N600"] = $5dfbdb9f0cfb9428$export$7090862dc3038a9f;
module.exports["N800"] = $5dfbdb9f0cfb9428$export$7d61b15e0da132af;
module.exports["N1000"] = $5dfbdb9f0cfb9428$export$f78789c8b01753cd;
module.exports["M50"] = $5dfbdb9f0cfb9428$export$dce26b47982a2d83;
module.exports["M200"] = $5dfbdb9f0cfb9428$export$a19f0c33186f7767;
module.exports["M400"] = $5dfbdb9f0cfb9428$export$a1d4686c17e1cdef;
module.exports["M600"] = $5dfbdb9f0cfb9428$export$3bff0a0c68537008;
module.exports["M800"] = $5dfbdb9f0cfb9428$export$aedcf6658caf5ad6;
module.exports["O200"] = $5dfbdb9f0cfb9428$export$51716a84e62e022c;
module.exports["Orange50"] = $5dfbdb9f0cfb9428$export$8692a80ca6403e1e;
module.exports["Orange200"] = $5dfbdb9f0cfb9428$export$a0fa9fa6bfbb29d1;
module.exports["Orange400"] = $5dfbdb9f0cfb9428$export$e58d39c2a9e7b70e;
module.exports["O600"] = $5dfbdb9f0cfb9428$export$65becf92d294645b;
module.exports["O800"] = $5dfbdb9f0cfb9428$export$d50a5202329f668e;
module.exports["P50"] = $5dfbdb9f0cfb9428$export$363e4475840015bb;
module.exports["P75"] = $5dfbdb9f0cfb9428$export$4b0a4417ed59760f;
module.exports["P100"] = $5dfbdb9f0cfb9428$export$6011520a64d9a187;
module.exports["PurpleBold"] = $5dfbdb9f0cfb9428$export$33050b411a4844fe;
module.exports["P200"] = $5dfbdb9f0cfb9428$export$a7175d4e9206bc80;
module.exports["P300"] = $5dfbdb9f0cfb9428$export$b48405b95304b5a1;
module.exports["P400"] = $5dfbdb9f0cfb9428$export$c71e4279dd54a18d;
module.exports["P500"] = $5dfbdb9f0cfb9428$export$147899de772240ec;
module.exports["T50"] = $5dfbdb9f0cfb9428$export$2cf711fe14c66f06;
module.exports["T75"] = $5dfbdb9f0cfb9428$export$7a8f4d33f6f9772c;
module.exports["T100"] = $5dfbdb9f0cfb9428$export$776c9c497ef08533;
module.exports["TealBold"] = $5dfbdb9f0cfb9428$export$f4de2950886ae4c9;
module.exports["T200"] = $5dfbdb9f0cfb9428$export$69cb3ca10c1e330e;
module.exports["T300"] = $5dfbdb9f0cfb9428$export$9dc1ef0f3f48059b;
module.exports["T500"] = $5dfbdb9f0cfb9428$export$6036577f95c3877e;

});

parcelRegister("evfc4", function(module, exports) {
var $e5c2b06b2fdf3428$exports = {};
$e5c2b06b2fdf3428$exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");



var $8Vojn = parcelRequire("8Vojn");


var $1EEhO = parcelRequire("1EEhO");


var $1tLuA = parcelRequire("1tLuA");

function $ff2abd300f68ac84$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ((0, $8Vojn.isHex)(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ((0, $1EEhO.isRgb)(color)) return (0, $1tLuA.rgbToHex)(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $e5c2b06b2fdf3428$exports.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $e5c2b06b2fdf3428$exports.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $e5c2b06b2fdf3428$exports.default[color];
        else if ($e5c2b06b2fdf3428$exports && $e5c2b06b2fdf3428$exports[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $e5c2b06b2fdf3428$exports[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
module.exports["normalizeHexColor"] = $ff2abd300f68ac84$export$b61655071712e690;

});

parcelRegister("8Vojn", function(module, exports) {
// eslint-disable-line import/no-namespace
const $550594d6a6380aa0$var$IS_HEX_REGEX = /^#([A-Fa-f0-9]{3}){1,2}$/u;
function $550594d6a6380aa0$export$8a9b6341a7c96bc(color) {
    return $550594d6a6380aa0$var$IS_HEX_REGEX.test(color);
}
module.exports["isHex"] = $550594d6a6380aa0$export$8a9b6341a7c96bc;

});

parcelRegister("1EEhO", function(module, exports) {
// eslint-disable-line import/no-namespace
const $2bbe12b11a845f75$var$IS_RGB_REGEX = /rgba?\(/u;
function $2bbe12b11a845f75$export$e698776ec826343(color) {
    return $2bbe12b11a845f75$var$IS_RGB_REGEX.test(color);
}
module.exports["isRgb"] = $2bbe12b11a845f75$export$e698776ec826343;

});

parcelRegister("1tLuA", function(module, exports) {
// eslint-disable-line import/no-namespace
function $f51e3a9d7a9c6283$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/gu);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}
module.exports["rgbToHex"] = $f51e3a9d7a9c6283$export$34d09c4a771c46ef;

});

parcelRegister("7IQ0H", function(module, exports) {
// eslint-disable-line import/no-namespace

var $evfc4 = parcelRequire("evfc4");

function $5af8242f4354cea0$export$9665a07d9187b414(rawColor, alpha) {
    const color = (0, $evfc4.normalizeHexColor)(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[a-z0-9]{2}/giu).map((hex)=>parseInt(hex, 16));
    };
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
module.exports["hexToRgba"] = $5af8242f4354cea0$export$9665a07d9187b414;

});

parcelRegister("k7ntk", function(module, exports) {
const $8ad6f05ccfe3f85e$var$SHORTHAND_HEX_REGEX = /^#?([a-f\d])([a-f\d])([a-f\d])$/iu;
const $8ad6f05ccfe3f85e$export$f67f480c2f5dd62d = (input)=>input.replace($8ad6f05ccfe3f85e$var$SHORTHAND_HEX_REGEX, (_m, r, g, b)=>r + r + g + g + b + b);


/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 







const $8ef1e3049ac57e55$export$c3a7521d0ffa04dc = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/iu;


const $3d7cb1e8c3547e43$export$d604f368c5212474 = (input)=>{
    const fullHex = (0, $8ad6f05ccfe3f85e$export$f67f480c2f5dd62d)(input);
    const result = (0, $8ef1e3049ac57e55$export$c3a7521d0ffa04dc).exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};


const $ab9148bdf39035e8$export$21f398e7d277f911 = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};


const $f0ac4d8f21e9695c$export$532d5190d94ac8d7 = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};


const $4778e0d4e31d777b$export$a7b197d2a22fcf09 = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });


const $df4b8ee3bcec3452$export$60714bf90ef24e7b = (rgb)=>(0, $ab9148bdf39035e8$export$21f398e7d277f911)((0, $4778e0d4e31d777b$export$a7b197d2a22fcf09)((0, $f0ac4d8f21e9695c$export$532d5190d94ac8d7)(rgb)));


const $3dedb51cf971d63c$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $3dedb51cf971d63c$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $3dedb51cf971d63c$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $3dedb51cf971d63c$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $3dedb51cf971d63c$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $3dedb51cf971d63c$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $3dedb51cf971d63c$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $3dedb51cf971d63c$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $3dedb51cf971d63c$var$lchToRgb = (lch)=>$3dedb51cf971d63c$var$xyzToRgb($3dedb51cf971d63c$var$labToXyz($3dedb51cf971d63c$var$lchToLab(lch)));
const $3dedb51cf971d63c$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = (0, $3d7cb1e8c3547e43$export$d604f368c5212474)(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = (0, $df4b8ee3bcec3452$export$60714bf90ef24e7b)(rgb);
    lch.l = $3dedb51cf971d63c$var$clamp(newPercent, 0, 100);
    return $3dedb51cf971d63c$var$rgbToHex($3dedb51cf971d63c$var$lchToRgb(lch));
};




const $1a58e03365721dec$var$getLightness = (color)=>{
    const rgb = (0, $3d7cb1e8c3547e43$export$d604f368c5212474)(color);
    if (rgb === null) return 0;
    const lch = (0, $df4b8ee3bcec3452$export$60714bf90ef24e7b)(rgb);
    return lch.l;
};
const $1a58e03365721dec$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $1a58e03365721dec$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return (0, $3dedb51cf971d63c$export$313b8a8fcb34c3b8)(currentBackgroundColor, newLightness).toUpperCase();
};
module.exports["getDarkModeLCHColor"] = $1a58e03365721dec$export$a5065c3b8aacaf99;

});

parcelRegister("jj5Xg", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports reassign shared mutable module local(s) [testGlobalTheme]; splitting would fork the singleton and is forbidden by TS2632 */ 
var $anBbz = parcelRequire("anBbz");


var $hFHBb = parcelRequire("hFHBb");


var $kf78l = parcelRequire("kf78l");


var $k7ntk = parcelRequire("k7ntk");


var $1QtCv = parcelRequire("1QtCv");


var $1tLuA = parcelRequire("1tLuA");

// used for extended palette in text color picker
const $cea277b6aca296ea$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $kf78l.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $kf78l.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $kf78l.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $kf78l.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $kf78l.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $kf78l.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $kf78l.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $kf78l.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $kf78l.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $kf78l.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $kf78l.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $kf78l.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $kf78l.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $kf78l.N0),
        'White'
    ],
    [
        (0, $kf78l.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $kf78l.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $kf78l.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $kf78l.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $kf78l.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $kf78l.P50),
        'Light purple'
    ] // Lavender secret
];
// experiment: platform_editor_lovability_text_bg_color
const $cea277b6aca296ea$var$colorArrayPaletteNew = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $kf78l.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $kf78l.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $kf78l.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $kf78l.L800),
        'Dark lime'
    ],
    [
        (0, $kf78l.Y800),
        'Dark yellow'
    ],
    [
        (0, $kf78l.O800),
        'Dark orange'
    ],
    [
        (0, $kf78l.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $kf78l.M800),
        'Dark magenta'
    ],
    [
        (0, $kf78l.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $kf78l.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $kf78l.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $kf78l.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $kf78l.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $kf78l.L600),
        'Lime'
    ],
    [
        (0, $kf78l.Y600),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $kf78l.O600),
        'Orange'
    ],
    [
        (0, $kf78l.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $kf78l.M600),
        'Magenta'
    ],
    [
        (0, $kf78l.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $kf78l.N0),
        'White'
    ],
    [
        (0, $kf78l.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $kf78l.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $kf78l.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $kf78l.L200),
        'Light lime'
    ],
    [
        (0, $kf78l.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $kf78l.Orange200),
        'Light orange'
    ],
    [
        (0, $kf78l.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $kf78l.M200),
        'Light magenta'
    ],
    [
        (0, $kf78l.P50),
        'Light purple'
    ] // Lavender secret
];
const $cea277b6aca296ea$export$569885e57444f84a = new Map();
const $cea277b6aca296ea$export$dee1d8a8cb3ab555 = new Map();
const $cea277b6aca296ea$export$81e5ed9e84fe2e28 = $cea277b6aca296ea$export$569885e57444f84a;
$cea277b6aca296ea$var$colorArrayPalette.forEach(([color, label])=>$cea277b6aca296ea$export$569885e57444f84a.set(color.toLowerCase(), label));
$cea277b6aca296ea$var$colorArrayPaletteNew.forEach(([color, label])=>$cea277b6aca296ea$export$dee1d8a8cb3ab555.set(color.toLowerCase(), label));
const $cea277b6aca296ea$var$isSupportedTextColor = (hexColor)=>{
    if ($cea277b6aca296ea$export$569885e57444f84a.has(hexColor)) return true;
    return (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $cea277b6aca296ea$export$dee1d8a8cb3ab555.has(hexColor);
};
// these are for test only
let $cea277b6aca296ea$var$testGlobalTheme;
const $cea277b6aca296ea$export$fd7e0dd2b74807f7 = (theme)=>{
    $cea277b6aca296ea$var$testGlobalTheme = theme;
};
const $cea277b6aca296ea$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($cea277b6aca296ea$var$testGlobalTheme) return {
        colorMode: $cea277b6aca296ea$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $cea277b6aca296ea$var$RGB_PREFIX_TEXT_COLOR_REGEX = /^rgb/iu;
const $cea277b6aca296ea$export$32f78bffcd82ff28 = (0, $hFHBb.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match($cea277b6aca296ea$var$RGB_PREFIX_TEXT_COLOR_REGEX)) hexColor = (0, $1tLuA.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $cea277b6aca296ea$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $cea277b6aca296ea$var$isSupportedTextColor(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $1QtCv.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($cea277b6aca296ea$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $k7ntk.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});
module.exports["colorPalette"] = $cea277b6aca296ea$export$569885e57444f84a;
module.exports["colorPaletteNew"] = $cea277b6aca296ea$export$dee1d8a8cb3ab555;
module.exports["colorPaletteExtended"] = $cea277b6aca296ea$export$81e5ed9e84fe2e28;
module.exports["getGlobalTheme"] = $cea277b6aca296ea$export$813ecdf77207a053;
module.exports["textColor"] = $cea277b6aca296ea$export$32f78bffcd82ff28;

});

parcelRegister("dWeA1", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");


var $kf78l = parcelRequire("kf78l");


var $4jl6R = parcelRequire("4jl6R");

function $4f11238cae8d1a78$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? (0, $4jl6R.editorBorderPalette)[hexColor.toUpperCase()] : undefined;
}


const $d4e95c3b3e2156ff$var$borderColorArrayPalette = [
    [
        (0, $kf78l.N300A),
        'Subtle gray'
    ],
    [
        (0, $kf78l.N600),
        'Gray'
    ],
    [
        (0, $kf78l.N1000),
        'Bold gray'
    ]
];
const $d4e95c3b3e2156ff$export$e4e044c989c86ca7 = new Map();
$d4e95c3b3e2156ff$var$borderColorArrayPalette.forEach(([color, label])=>$d4e95c3b3e2156ff$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $d4e95c3b3e2156ff$export$1edee58a52776cd9 = (0, $hFHBb.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const color = (dom.getAttribute('data-color') ?? '').toLowerCase();
                const size = +(dom.getAttribute('data-size') ?? '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $d4e95c3b3e2156ff$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $4f11238cae8d1a78$export$bad3c41dd33cb4bc)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});
module.exports["borderColorPalette"] = $d4e95c3b3e2156ff$export$e4e044c989c86ca7;
module.exports["border"] = $d4e95c3b3e2156ff$export$1edee58a52776cd9;

});

parcelRegister("acWDI", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $5aa9e82185c941db$var$allowedTypes = [
    'wide',
    'full-width'
];
const $5aa9e82185c941db$export$89015c65f1c75e3f = (0, $hFHBb.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const width = dom.getAttribute('data-width');
                return {
                    mode: $5aa9e82185c941db$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': mark.attrs?.width
            },
            0
        ];
    }
});
module.exports["breakout"] = $5aa9e82185c941db$export$89015c65f1c75e3f;

});

parcelRegister("bwEl8", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $507c5fb6ee89e882$export$6565f9f03506010b = (0, $hFHBb.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});
module.exports["code"] = $507c5fb6ee89e882$export$6565f9f03506010b;

});

parcelRegister("1yopN", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $606ba856d7ca291f$export$f3b72f8fc4684ecd = (0, $hFHBb.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});
module.exports["confluenceInlineComment"] = $606ba856d7ca291f$export$f3b72f8fc4684ecd;

});

parcelRegister("kHCzj", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");


var $kaBfx = parcelRequire("kaBfx");

const $d64f3c6b3909df83$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $kaBfx.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $d64f3c6b3909df83$export$3024f02c495408d6 = (0, $hFHBb.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$d64f3c6b3909df83$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $d64f3c6b3909df83$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};
module.exports["dataConsumer"] = $d64f3c6b3909df83$export$3024f02c495408d6;
module.exports["toJSON"] = $d64f3c6b3909df83$export$54fd2c36b5cc6731;

});

parcelRegister("6nekq", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $a8456ac0822da1bf$var$emDOM = [
    'em'
];
const $a8456ac0822da1bf$export$c63c6f932822f543 = (0, $hFHBb.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $a8456ac0822da1bf$var$emDOM;
    }
});
module.exports["em"] = $a8456ac0822da1bf$export$c63c6f932822f543;

});

parcelRegister("4Fod8", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $128cdaa202f0ab8b$var$allowedSizes = [
    'small'
];
const $128cdaa202f0ab8b$export$85e3c3ca0c6fb93 = (0, $hFHBb.fontSize)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-font-size',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const fontSize = dom.getAttribute('data-font-size');
                return {
                    fontSize: $128cdaa202f0ab8b$var$allowedSizes.indexOf(fontSize || '') === -1 ? 'small' : fontSize
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-font-size',
                'data-font-size': mark.attrs.fontSize
            },
            0
        ];
    }
});
module.exports["fontSize"] = $128cdaa202f0ab8b$export$85e3c3ca0c6fb93;

});

parcelRegister("hwsSH", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");


var $kaBfx = parcelRequire("kaBfx");

const $8efc0f5bc0914369$var$parseFragment = (maybeValue)=>{
    if (!(0, $kaBfx.isDOMElement)(maybeValue)) return false;
    const name = maybeValue.getAttribute('data-name') ?? undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $8efc0f5bc0914369$export$f00aeb236b6f05af = (0, $hFHBb.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$8efc0f5bc0914369$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $8efc0f5bc0914369$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};
module.exports["fragment"] = $8efc0f5bc0914369$export$f00aeb236b6f05af;
module.exports["toJSON"] = $8efc0f5bc0914369$export$54fd2c36b5cc6731;

});

parcelRegister("7toP7", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $44c8abae69fe372d$export$480c699bd4ec0d86 = (0, $hFHBb.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});
module.exports["indentation"] = $44c8abae69fe372d$export$480c699bd4ec0d86;

});

parcelRegister("3uRAA", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $hFHBb = parcelRequire("hFHBb");


var $73a6g = parcelRequire("73a6g");


var $cogHp = parcelRequire("cogHp");





var $hXiLX = parcelRequire("hXiLX");

const $a53e0c34cf5b7c5f$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $73a6g.isSafeUrl)(href)) return false;
        if ((0, $cogHp.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $hXiLX.normalizeUrl)(href);
        return attrs;
    };



const $c63c671227617ce6$export$9c30223ca0a664fb = (0, $hFHBb.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: (0, $a53e0c34cf5b7c5f$export$b5f67017585d1431)('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: (0, $a53e0c34cf5b7c5f$export$b5f67017585d1431)('href')
        }
    ],
    toDOM (node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $73a6g.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
module.exports["link"] = $c63c671227617ce6$export$9c30223ca0a664fb;

});

parcelRegister("73a6g", function(module, exports) {
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ const $ed56fc1686c1f708$var$whitelistedURLPatterns = [
    /^https?:\/\//imu,
    /^ftps?:\/\//imu,
    /^gopher:\/\//imu,
    /^integrity:\/\//imu,
    /^file:\/\//imu,
    /^smb:\/\//imu,
    /^dynamicsnav:\/\//imu,
    /^jamfselfservice:\/\//imu,
    /^\//imu,
    /^mailto:/imu,
    /^skype:/imu,
    /^callto:/imu,
    /^facetime:/imu,
    /^git:/imu,
    /^irc6?:/imu,
    /^news:/imu,
    /^nntp:/imu,
    /^feed:/imu,
    /^cvs:/imu,
    /^svn:/imu,
    /^mvn:/imu,
    /^ssh:/imu,
    /^scp:\/\//imu,
    /^sftp:\/\//imu,
    /^itms:/imu,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/imu,
    /^notes:\/\//imu,
    /^hipchat:\/\//imu,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/imu,
    /^sourcetree:\/\//imu,
    /^urn:/imu,
    /^tel:/imu,
    /^xmpp:/imu,
    /^telnet:/imu,
    /^vnc:/imu,
    /^rdp:/imu,
    /^whatsapp:/imu,
    /^slack:/imu,
    /^sips?:/imu,
    /^magnet:/imu,
    /^#/imu
];
const $ed56fc1686c1f708$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url?.trim();
    if (urlTrimmed === undefined) return true;
    if (urlTrimmed.length === 0) return true;
    return $ed56fc1686c1f708$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
module.exports["isSafeUrl"] = $ed56fc1686c1f708$export$c9f92f5469372e0f;

});

parcelRegister("cogHp", function(module, exports) {
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ /**
 * checks if root relative link
 */ function $fae54c93e6f98ec5$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}
module.exports["isRootRelative"] = $fae54c93e6f98ec5$export$23579274a7a24f7b;

});

parcelRegister("hXiLX", function(module, exports) {
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $igmrL = parcelRequire("igmrL");

function $0c8e288dab6497b8$export$6535eb414fa2c8b6(url) {
    const match = (0, $igmrL.getLinkMatch)(url);
    return match && match.url || '';
}
module.exports["normalizeUrl"] = $0c8e288dab6497b8$export$6535eb414fa2c8b6;

});

parcelRegister("igmrL", function(module, exports) {
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $tgKCV = parcelRequire("tgKCV");


var $9p0BY = parcelRequire("9p0BY");

function $080ecb9b3dc271ce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = (0, $tgKCV.linkifyMatch)(str);
    if (!match.length) match = (0, $9p0BY.linkify).match(str);
    return match && match[0];
}
module.exports["getLinkMatch"] = $080ecb9b3dc271ce$export$ce9ae45aed3e4ec;

});

parcelRegister("tgKCV", function(module, exports) {
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $9p0BY = parcelRequire("9p0BY");

const $01573be574f020b2$export$6f7d7761b97f967 = (text)=>{
    if (!(0, $9p0BY.LINK_REGEXP).test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    substr = text.substr(startpos);
    while(substr){
        const link = (substr.match((0, $9p0BY.LINK_REGEXP)) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search((0, $9p0BY.LINK_REGEXP));
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};
module.exports["linkifyMatch"] = $01573be574f020b2$export$6f7d7761b97f967;

});

parcelRegister("9p0BY", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ /**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $tALAR = parcelRequire("tALAR");


var $iDrrr = parcelRequire("iDrrr");


var $73a6g = parcelRequire("73a6g");





const $58b83256e07d7036$export$8ccbde94d5c7f8e7 = new (0, $tALAR.default)();
const $58b83256e07d7036$var$URI_WITHOUT_SPACES = /[^\s]+/u;
const $58b83256e07d7036$var$URI_WITHOUT_SPACES_ANCHORED = /^[^\s]+/u;
const $58b83256e07d7036$var$urlWithoutSpacesValidator = {
    validate: (text, pos)=>{
        const tail = text.slice(pos);
        const pattern = (0, $iDrrr.fg)('platform_bugfix_invalid_urls_parsing_in_editor') ? $58b83256e07d7036$var$URI_WITHOUT_SPACES_ANCHORED : $58b83256e07d7036$var$URI_WITHOUT_SPACES;
        const match = tail.match(pattern);
        return match ? match[0].length : 0;
    }
};
const $58b83256e07d7036$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $58b83256e07d7036$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
const $58b83256e07d7036$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/u;
$58b83256e07d7036$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$58b83256e07d7036$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
$58b83256e07d7036$export$8ccbde94d5c7f8e7.add('tel:', $58b83256e07d7036$var$urlWithoutSpacesValidator);
$58b83256e07d7036$export$8ccbde94d5c7f8e7.add('file:', $58b83256e07d7036$var$urlWithoutSpacesValidator);
$58b83256e07d7036$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
$58b83256e07d7036$var$tlds.push($58b83256e07d7036$var$tlds2Char);
$58b83256e07d7036$export$8ccbde94d5c7f8e7.tlds($58b83256e07d7036$var$tlds, false);
module.exports["linkify"] = $58b83256e07d7036$export$8ccbde94d5c7f8e7;
module.exports["LINK_REGEXP"] = $58b83256e07d7036$export$746d02eae03c72e1;

});

parcelRegister("fyiBi", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $5400955bb947e2e6$export$4899a95d70ec5056 = (0, $hFHBb.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});
module.exports["strike"] = $5400955bb947e2e6$export$4899a95d70ec5056;

});

parcelRegister("fa9Se", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $69bd9cf0e17538f6$var$strongDOM = [
    'strong'
];
const $69bd9cf0e17538f6$var$BOLD_FONT_WEIGHT_REGEX = /^(bold(er)?|[5-9]\d{2,})$/u;
const $69bd9cf0e17538f6$export$59ae2c325a998f89 = (0, $hFHBb.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || $69bd9cf0e17538f6$var$BOLD_FONT_WEIGHT_REGEX.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $69bd9cf0e17538f6$var$strongDOM;
    }
});
module.exports["strong"] = $69bd9cf0e17538f6$export$59ae2c325a998f89;

});

parcelRegister("lhe5G", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

function $0a14b49585d2e952$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $0a14b49585d2e952$export$b3401ee80eb31041 = (0, $hFHBb.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$0a14b49585d2e952$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$0a14b49585d2e952$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});
module.exports["subsup"] = $0a14b49585d2e952$export$b3401ee80eb31041;

});

parcelRegister("koZsE", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");


var $kf78l = parcelRequire("kf78l");

const $79b02a3b17c3e93d$export$20af3dabbb5538df = (0, $hFHBb.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $kf78l.B400)}`
            }
        ];
    }
});
module.exports["typeAheadQuery"] = $79b02a3b17c3e93d$export$20af3dabbb5538df;

});

parcelRegister("cI9Wu", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $472feb293228fed1$export$425327af25286e5e = (0, $hFHBb.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});
module.exports["underline"] = $472feb293228fed1$export$425327af25286e5e;

});

parcelRegister("bliHm", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $ea0fff0b88b8f10f$export$30d78d5eb6719bb8 = (0, $hFHBb.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});
module.exports["unsupportedMark"] = $ea0fff0b88b8f10f$export$30d78d5eb6719bb8;

});

parcelRegister("jZlhw", function(module, exports) {

var $hFHBb = parcelRequire("hFHBb");

const $758f7255c61ac577$export$a316dc07ff5182a2 = (0, $hFHBb.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});
module.exports["unsupportedNodeAttribute"] = $758f7255c61ac577$export$a316dc07ff5182a2;

});

parcelRegister("azoPw", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $9bd015de1953428b$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $9bd015de1953428b$export$c4c2f833baaebdb8 = (0, $472n0.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$9bd015de1953428b$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$9bd015de1953428b$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            node?.attrs?.url || ' '
        ];
    }
});
const $9bd015de1953428b$export$9894f24949f094e5 = (0, $472n0.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$9bd015de1953428b$var$getCommonAttributesFromDom(dom),
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$9bd015de1953428b$var$getCommonAttributesFromDom(dom),
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'a',
            attrs,
            node?.attrs?.url || ' '
        ];
    }
});
module.exports["blockCard"] = $9bd015de1953428b$export$c4c2f833baaebdb8;
module.exports["blockCardWithLocalId"] = $9bd015de1953428b$export$9894f24949f094e5;

});

parcelRegister("4zK3y", function(module, exports) {
const $f94ed5590ebfb05f$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
module.exports["createPMNodeSpecFactory"] = $f94ed5590ebfb05f$export$bf0a80f00e2b8ff6;

});

parcelRegister("2nOF5", function(module, exports) {
const $f01e37d6f1388a96$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/gu, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
let $f01e37d6f1388a96$var$staticValue = false;
const $f01e37d6f1388a96$export$31b40729666a4ae0 = {
    setStatic (value) {
        $f01e37d6f1388a96$var$staticValue = value;
    },
    generate () {
        return $f01e37d6f1388a96$var$staticValue || $f01e37d6f1388a96$export$1c3aefb711c3a4cc();
    }
};
module.exports["generateUuid"] = $f01e37d6f1388a96$export$1c3aefb711c3a4cc;
module.exports["uuid"] = $f01e37d6f1388a96$export$31b40729666a4ae0;

});

parcelRegister("9ehdj", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $c772ee8acbd535f5$export$6d8b0ef52e2e6390 = (0, $472n0.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2nOF5.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c772ee8acbd535f5$export$16018c61064a18df = (0, $472n0.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2nOF5.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["taskItem"] = $c772ee8acbd535f5$export$6d8b0ef52e2e6390;
module.exports["blockTaskItem"] = $c772ee8acbd535f5$export$16018c61064a18df;

});

parcelRegister("04Oo7", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $kOd4H = parcelRequire("kOd4H");

const $64939c8f60c9dee6$export$27903d543b563e39 = (0, $472n0.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $kOd4H.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $64939c8f60c9dee6$export$8bbe5aa5bba36cc1 = {
    ...$64939c8f60c9dee6$export$27903d543b563e39,
    marks: `breakout ${$64939c8f60c9dee6$export$27903d543b563e39.marks}`
};
module.exports["bodiedExtension"] = $64939c8f60c9dee6$export$27903d543b563e39;
module.exports["bodiedExtensionRootOnlyStage0"] = $64939c8f60c9dee6$export$8bbe5aa5bba36cc1;

});

parcelRegister("c0Rae", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $b06c5cbe8b2603cf$export$e92c7e4302dd4371 = (0, $472n0.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $2nOF5.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});
module.exports["bodiedSyncBlock"] = $b06c5cbe8b2603cf$export$e92c7e4302dd4371;

});

parcelRegister("9nUB4", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $243fa11ffeedc385$export$5f25a39efab3b58b = '.ak-ul';
const $243fa11ffeedc385$export$a140c94e5ea26bee = (0, $472n0.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $243fa11ffeedc385$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
const $243fa11ffeedc385$export$dfd406053b2bab40 = (0, $472n0.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: ()=>{
                return {
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            class: $243fa11ffeedc385$export$5f25a39efab3b58b.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
module.exports["bulletListSelector"] = $243fa11ffeedc385$export$5f25a39efab3b58b;
module.exports["bulletList"] = $243fa11ffeedc385$export$a140c94e5ea26bee;
module.exports["bulletListWithLocalId"] = $243fa11ffeedc385$export$dfd406053b2bab40;

});

parcelRegister("c94QJ", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $f70d9f094f7e44ae$export$8e3c2dfdc4f0453d = (0, $472n0.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
const $f70d9f094f7e44ae$export$b5d01ee303c467aa = (0, $472n0.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: ()=>{
                return {
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-caption': 'true'
        };
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
module.exports["caption"] = $f70d9f094f7e44ae$export$8e3c2dfdc4f0453d;
module.exports["captionWithLocalId"] = $f70d9f094f7e44ae$export$b5d01ee303c467aa;

});

parcelRegister("jDAs4", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $cb1643b6288b18a5$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $cb1643b6288b18a5$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $cb1643b6288b18a5$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $cb1643b6288b18a5$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $cb1643b6288b18a5$var$LANGUAGE_CLASS_REGEX = /(?:^|\s)language-([^\s]+)/u;
const $cb1643b6288b18a5$var$TRAILING_NEWLINE_REGEX = /\n$/u;
const $cb1643b6288b18a5$var$extractLanguageFromClass = (className)=>{
    const result = $cb1643b6288b18a5$var$LANGUAGE_CLASS_REGEX.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $cb1643b6288b18a5$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace($cb1643b6288b18a5$var$TRAILING_NEWLINE_REGEX, '');
    return dom;
};
function $cb1643b6288b18a5$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $cb1643b6288b18a5$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $cb1643b6288b18a5$export$7bb0d5c671655cc4 = (0, $472n0.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $cb1643b6288b18a5$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $cb1643b6288b18a5$var$getLanguageFromEditorStyle(dom.parentElement) || $cb1643b6288b18a5$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $cb1643b6288b18a5$var$removeLastNewLine(dom);
                const wrapAttr = dom.getAttribute('data-wrap');
                const isCopiedFromEditor = Boolean(dom.closest('[data-pm-slice]') || dom.hasAttribute('data-pm-slice'));
                // Default external HTML paste to wrapped when data-wrap is absent, but preserve
                // unwrapped editor-origin paste when copied content has data-pm-slice.
                const wrap = wrapAttr === null ? !isCopiedFromEditor : wrapAttr !== 'false';
                const hideLineNumbers = dom.getAttribute('data-hide-line-numbers') === 'true';
                return {
                    language: language,
                    wrap: wrap,
                    hideLineNumbers: hideLineNumbers,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {
                    wrap: true
                };
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $cb1643b6288b18a5$var$parseCodeFromHtml(domNode);
                return code ? (0, $aPdNQ.Fragment).from(schema.text(code)) : (0, $aPdNQ.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {
                    wrap: true
                };
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {
                    wrap: true
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {};
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        // Always serialize data-wrap explicitly (both true and false) so that
        // editor-to-editor paste can distinguish intentional wrap:false from
        // absent data-wrap (which parseDOM defaults to wrap:true for external HTML).
        attrs['data-wrap'] = node.attrs.wrap ? 'true' : 'false';
        if (node.attrs.hideLineNumbers) attrs['data-hide-line-numbers'] = 'true';
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $cb1643b6288b18a5$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            if (key === 'wrap' && node.attrs.wrap === null) return memo;
            if (key === 'hideLineNumbers' && !node.attrs.hideLineNumbers) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });
const $cb1643b6288b18a5$export$3f75de798a0b5356 = (0, $472n0.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $cb1643b6288b18a5$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $cb1643b6288b18a5$var$getLanguageFromEditorStyle(dom.parentElement) || $cb1643b6288b18a5$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $cb1643b6288b18a5$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $cb1643b6288b18a5$var$parseCodeFromHtml(domNode);
                return code ? (0, $aPdNQ.Fragment).from(schema.text(code)) : (0, $aPdNQ.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        const attrs = {};
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
module.exports["codeBlock"] = $cb1643b6288b18a5$export$7bb0d5c671655cc4;
module.exports["toJSON"] = $cb1643b6288b18a5$export$54fd2c36b5cc6731;
module.exports["codeBlockWithLocalId"] = $cb1643b6288b18a5$export$3f75de798a0b5356;

});

parcelRegister("9zObh", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $1f214e1a17634f84$var$name = 'confluenceJiraIssue';
const $1f214e1a17634f84$export$daf889beb5092f95 = (0, $472n0.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$1f214e1a17634f84$var$name}"]`,
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $1f214e1a17634f84$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});
module.exports["confluenceJiraIssue"] = $1f214e1a17634f84$export$daf889beb5092f95;

});

parcelRegister("g185T", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $15def6c333b69ab9$var$name = 'confluenceUnsupportedBlock';
const $15def6c333b69ab9$export$e6e4878f43c27cab = (0, $472n0.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $15def6c333b69ab9$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$15def6c333b69ab9$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});
module.exports["confluenceUnsupportedBlock"] = $15def6c333b69ab9$export$e6e4878f43c27cab;

});

parcelRegister("1E9VS", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $7ebe11d6bfa92b70$var$name = 'confluenceUnsupportedInline';
const $7ebe11d6bfa92b70$export$3e6d667072febc87 = (0, $472n0.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $7ebe11d6bfa92b70$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$7ebe11d6bfa92b70$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});
module.exports["confluenceUnsupportedInline"] = $7ebe11d6bfa92b70$export$3e6d667072febc87;

});

parcelRegister("eq809", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $0162fa8c6d43e134$export$324d90190a8b822a = (0, $472n0.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
const $0162fa8c6d43e134$export$a6a035390e3921b2 = (0, $472n0.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});
module.exports["date"] = $0162fa8c6d43e134$export$324d90190a8b822a;
module.exports["dateWithLocalId"] = $0162fa8c6d43e134$export$a6a035390e3921b2;

});

parcelRegister("98Lj8", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $9f53cdfd571108a7$export$6959e16eeff859b4 = (0, $472n0.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2nOF5.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});
module.exports["decisionItem"] = $9f53cdfd571108a7$export$6959e16eeff859b4;

});

parcelRegister("kAzEy", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $d7d4928c0f00c358$var$name = 'decisionList';
const $d7d4928c0f00c358$export$a5393ce68c2ff601 = `[data-node-type="${$d7d4928c0f00c358$var$name}"]`;
const $d7d4928c0f00c358$export$62d45a65fb43d95e = (0, $472n0.decisionList)({
    parseDOM: [
        {
            tag: `ol${$d7d4928c0f00c358$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $d7d4928c0f00c358$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
module.exports["decisionListSelector"] = $d7d4928c0f00c358$export$a5393ce68c2ff601;
module.exports["decisionList"] = $d7d4928c0f00c358$export$62d45a65fb43d95e;

});

parcelRegister("5SlVI", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $565971f8f49c71e0$export$2a111da947c407d2 = (0, $472n0.doc)({});
module.exports["doc"] = $565971f8f49c71e0$export$2a111da947c407d2;

});

parcelRegister("dtmRZ", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $b8a468944c963c38$export$be4283d9a1cb1ff6 = (0, $472n0.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
const $b8a468944c963c38$export$36734475a7f6fd3e = (0, $472n0.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});
module.exports["embedCard"] = $b8a468944c963c38$export$be4283d9a1cb1ff6;
module.exports["embedCardWithLocalId"] = $b8a468944c963c38$export$36734475a7f6fd3e;

});

parcelRegister("kOOm4", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $lqFew = parcelRequire("lqFew");


var $gNfMq = parcelRequire("gNfMq");


var $2nOF5 = parcelRequire("2nOF5");

const $dc51790223cf45cc$export$a19185d1233fc4b2 = (0, $472n0.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: (dom)=>(0, $lqFew.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: (dom)=>(0, $gNfMq.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $dc51790223cf45cc$export$ebb3b3c7a0ac9936 = (0, $472n0.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const attrs = (0, $lqFew.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const attrs = (0, $gNfMq.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $dc51790223cf45cc$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["emoji"] = $dc51790223cf45cc$export$a19185d1233fc4b2;
module.exports["emojiWithLocalId"] = $dc51790223cf45cc$export$ebb3b3c7a0ac9936;

});

parcelRegister("lqFew", function(module, exports) {

var $hFoua = parcelRequire("hFoua");


var $4inos = parcelRequire("4inos");

function $40837c53c617977e$export$f61e93bda2a8b420(acName) {
    const emojiData = (0, $hFoua.acNameToEmojiMap)[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: (0, $4inos.DEFAULT_EMOJI_ID),
        shortName: `:${acName}:`,
        text: ''
    };
}
module.exports["acNameToEmoji"] = $40837c53c617977e$export$f61e93bda2a8b420;

});

parcelRegister("hFoua", function(module, exports) {
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $4eae92e5a5f85e16$export$7962498ea8ccffac = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
module.exports["acNameToEmojiMap"] = $4eae92e5a5f85e16$export$7962498ea8ccffac;

});

parcelRegister("4inos", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 




const $8b0dfb4e845ae0c0$export$936e67708ade64a9 = '2b50';
const $8b0dfb4e845ae0c0$export$209b328f48821d5f = 'blue-star';
const $8b0dfb4e845ae0c0$export$1c102a772ecd912c = 'atlassian-';
module.exports["DEFAULT_EMOJI_ID"] = $8b0dfb4e845ae0c0$export$936e67708ade64a9;
module.exports["DEFAULT_EMOJI_ACNAME"] = $8b0dfb4e845ae0c0$export$209b328f48821d5f;
module.exports["HC_EMOTICON_PREFIX"] = $8b0dfb4e845ae0c0$export$1c102a772ecd912c;

});

parcelRegister("gNfMq", function(module, exports) {

var $4inos = parcelRequire("4inos");

function $fa67d66389072dca$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${0, $4inos.HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
module.exports["acShortcutToEmoji"] = $fa67d66389072dca$export$441f8b58f5790a68;

});

parcelRegister("chuMh", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

function $3e5a500049219548$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $3e5a500049219548$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $3e5a500049219548$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $3e5a500049219548$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $3e5a500049219548$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $3e5a500049219548$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $3e5a500049219548$export$7b80cba28d10b2c1 = (0, $472n0.expand)($3e5a500049219548$var$nodeSpecOptions);
const $3e5a500049219548$export$2ae5e7565ff9ffa6 = (0, $472n0.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $3e5a500049219548$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $3e5a500049219548$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $3e5a500049219548$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $3e5a500049219548$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $3e5a500049219548$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
module.exports["expandWithNestedExpand"] = $3e5a500049219548$export$7b80cba28d10b2c1;
module.exports["expandWithNestedExpandLocalId"] = $3e5a500049219548$export$2ae5e7565ff9ffa6;
module.exports["toJSON"] = $3e5a500049219548$export$54fd2c36b5cc6731;

});

parcelRegister("9oc8s", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $c3380208f25c290b$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $c3380208f25c290b$export$67dc04e652a298ca = (0, $472n0.blockquoteLegacy)($c3380208f25c290b$var$nodeSpecOptions);
const $c3380208f25c290b$export$70a64939da3e8455 = (0, $472n0.blockquote)($c3380208f25c290b$var$nodeSpecOptions);
const $c3380208f25c290b$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: ()=>{
                return {
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'blockquote',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
};
const $c3380208f25c290b$export$950ebf43f3364a0f = (0, $472n0.blockquote)($c3380208f25c290b$var$nodeSpecOptionsWithLocalId);
module.exports["blockquote"] = $c3380208f25c290b$export$67dc04e652a298ca;
module.exports["extendedBlockquote"] = $c3380208f25c290b$export$70a64939da3e8455;
module.exports["extendedBlockquoteWithLocalId"] = $c3380208f25c290b$export$950ebf43f3364a0f;

});

parcelRegister("7XIUO", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $jSLz8 = parcelRequire("jSLz8");

const $d41d82001c806eba$export$ce20b13564211141 = (allowCustomPanel)=>(0, $472n0.panel)((0, $jSLz8.createPanelNodeSpecOptions)(allowCustomPanel));
module.exports["extendedPanel"] = $d41d82001c806eba$export$ce20b13564211141;

});

parcelRegister("jVdlG", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 








var $56be3a0ac801be4f$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
module.exports["PanelType"] = $56be3a0ac801be4f$export$969277cf61e5a7aa;

});

parcelRegister("aIF2y", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $jSLz8 = parcelRequire("jSLz8");

const $5a4972f0fb47577b$export$855c3c67c9c9ebaf = (allowCustomPanel)=>(0, $472n0.panel)((0, $jSLz8.createPanelNodeSpecOptions)(allowCustomPanel, true));
module.exports["extendedPanelWithLocalId"] = $5a4972f0fb47577b$export$855c3c67c9c9ebaf;

});

parcelRegister("7Tmz1", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $jSLz8 = parcelRequire("jSLz8");

const $56fd80ccaf2d2d20$export$c158ac2988d2f011 = (allowCustomPanel)=>(0, $472n0.panelC1Stage0)((0, $jSLz8.createPanelNodeSpecOptions)(allowCustomPanel));
module.exports["extendedPanelC1"] = $56fd80ccaf2d2d20$export$c158ac2988d2f011;

});

parcelRegister("i6nlo", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $jSLz8 = parcelRequire("jSLz8");

const $acd291c173f7a0fd$export$9c65e35ecb68f683 = (allowCustomPanel)=>(0, $472n0.panelC1Stage0)((0, $jSLz8.createPanelNodeSpecOptions)(allowCustomPanel, true));
module.exports["extendedPanelC1WithLocalId"] = $acd291c173f7a0fd$export$9c65e35ecb68f683;

});

parcelRegister("7PeFT", function(module, exports) {

var $aIF2y = parcelRequire("aIF2y");

const $b4bac9303469b793$export$71123ea8f73a7fb = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $aIF2y.extendedPanelWithLocalId)(allowCustomPanel);
    return {
        ...panelNodeSpec,
        marks: `breakout ${panelNodeSpec.marks}`
    };
};
module.exports["extendedPanelRootOnlyStage0"] = $b4bac9303469b793$export$71123ea8f73a7fb;

});

parcelRegister("2Vlq9", function(module, exports) {

var $i6nlo = parcelRequire("i6nlo");

const $81e12fb13c2586b0$export$9ef8544aba133962 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $i6nlo.extendedPanelC1WithLocalId)(allowCustomPanel);
    return {
        ...panelNodeSpec,
        marks: `breakout ${panelNodeSpec.marks}`
    };
};
module.exports["extendedPanelC1RootOnlyStage0"] = $81e12fb13c2586b0$export$9ef8544aba133962;

});

parcelRegister("hVgcP", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $kOd4H = parcelRequire("kOd4H");

const $47a3a9f15ea9fc74$export$1b45514b112dd749 = (0, $472n0.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $kOd4H.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});
const $47a3a9f15ea9fc74$export$ad06037362b3c3b3 = {
    ...$47a3a9f15ea9fc74$export$1b45514b112dd749,
    marks: 'breakout dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};
const $47a3a9f15ea9fc74$export$3e3366ebd634cc62 = {
    ...$47a3a9f15ea9fc74$export$1b45514b112dd749,
    marks: 'annotation dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};
const $47a3a9f15ea9fc74$export$243bc54b0560ecc = {
    ...$47a3a9f15ea9fc74$export$1b45514b112dd749,
    marks: 'annotation breakout dataConsumer fragment unsupportedMark unsupportedNodeAttribute'
};
module.exports["extension"] = $47a3a9f15ea9fc74$export$1b45514b112dd749;
module.exports["extensionRootOnlyStage0"] = $47a3a9f15ea9fc74$export$ad06037362b3c3b3;
module.exports["extensionWithAnnotationStage0"] = $47a3a9f15ea9fc74$export$3e3366ebd634cc62;
module.exports["extensionRootOnlyWithAnnotationStage0"] = $47a3a9f15ea9fc74$export$243bc54b0560ecc;

});

parcelRegister("ixHGM", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $kOd4H = parcelRequire("kOd4H");

const $b44265b26fb0c5d7$export$4fdcae991fd743e7 = (0, $472n0.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true',
            // Frames are hidden by default and the active frame is revealed via CSS.
            // Using an inline style ensures frames are invisible from the moment
            // ProseMirror inserts them into the DOM, preventing a flash of all
            // frames before the styles are injected.
            style: 'display:none'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $b44265b26fb0c5d7$export$c3c04d555a8b9013 = (0, $472n0.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $kOd4H.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $b44265b26fb0c5d7$export$6f4c18ddc3950a66 = {
    ...$b44265b26fb0c5d7$export$c3c04d555a8b9013,
    marks: `breakout ${$b44265b26fb0c5d7$export$c3c04d555a8b9013.marks}`
};
module.exports["extensionFrame"] = $b44265b26fb0c5d7$export$4fdcae991fd743e7;
module.exports["multiBodiedExtension"] = $b44265b26fb0c5d7$export$c3c04d555a8b9013;
module.exports["multiBodiedExtensionRootOnlyStage0"] = $b44265b26fb0c5d7$export$6f4c18ddc3950a66;

});

parcelRegister("ioLmC", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $bad09377b26ad4d0$export$371da9dd35aba193 = (0, $472n0.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});
module.exports["hardBreak"] = $bad09377b26ad4d0$export$371da9dd35aba193;

});

parcelRegister("3RygG", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $f00d07bb0a0eea13$var$getAttrs = (level)=>(domNode)=>({
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        });
const $f00d07bb0a0eea13$export$46e4a324ac90507f = (0, $472n0.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $f00d07bb0a0eea13$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});
module.exports["heading"] = $f00d07bb0a0eea13$export$46e4a324ac90507f;

});

parcelRegister("234td", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $13d7a2f955e63612$export$5c452ff88e35e47d = (0, $472n0.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});
module.exports["image"] = $13d7a2f955e63612$export$5c452ff88e35e47d;

});

parcelRegister("dYkuB", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $14201e157179d403$export$cbf8224b64e0d942 = (0, $472n0.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
const $14201e157179d403$export$7ed775fc743eadd1 = (0, $472n0.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $2nOF5.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': node?.attrs?.localId || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
module.exports["inlineCard"] = $14201e157179d403$export$cbf8224b64e0d942;
module.exports["inlineCardWithLocalId"] = $14201e157179d403$export$7ed775fc743eadd1;

});

parcelRegister("20WsY", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $kOd4H = parcelRequire("kOd4H");

const $a4f2688aaf2c17a3$export$16b353b2649bd8d9 = (0, $472n0.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $kOd4H.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});
module.exports["inlineExtension"] = $a4f2688aaf2c17a3$export$16b353b2649bd8d9;

});

parcelRegister("6UUJT", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");


var $mrh47 = parcelRequire("mrh47");

const $4006f3dbb1a9689a$var$setColumnAttributes = (node, { withLocalId: withLocalId = false } = {})=>{
    const attrs = {
        'data-layout-column': 'true'
    };
    const { width: width, valign: valign, localId: localId } = node.attrs;
    if (width) {
        const baseStyle = `flex-basis: ${width}%`;
        attrs['style'] = `${baseStyle}; --column-width: ${width}%`;
        attrs['data-column-width'] = `${width}`;
    }
    if (valign) attrs['data-valign'] = valign;
    if (withLocalId && localId) attrs['data-local-id'] = localId;
    return attrs;
};
const $4006f3dbb1a9689a$var$getColumnAttrs = ({ withLocalId: withLocalId = false } = {})=>(domNode)=>{
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dom = domNode;
        const base = {
            width: Number(dom.getAttribute('data-column-width')) || undefined,
            ...withLocalId && {
                localId: (0, $2nOF5.uuid).generate()
            }
        };
        const valign = (0, $mrh47.parseValign)(dom.getAttribute('data-valign'));
        return valign ? {
            ...base,
            valign: valign
        } : base;
    };
// We need to apply an attribute to the innermost child to help ProseMirror
// identify its boundaries better.
const $4006f3dbb1a9689a$var$LAYOUT_CONTENT_ATTRS = {
    'data-layout-content': 'true'
};
const $4006f3dbb1a9689a$export$ab76e7c03cd6f650 = (0, $472n0.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $4006f3dbb1a9689a$var$getColumnAttrs()
        }
    ],
    toDOM (node) {
        return [
            'div',
            $4006f3dbb1a9689a$var$setColumnAttributes(node),
            [
                'div',
                $4006f3dbb1a9689a$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $4006f3dbb1a9689a$export$b2e27d292505bac2 = (0, $472n0.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $4006f3dbb1a9689a$var$getColumnAttrs({
                withLocalId: true
            })
        }
    ],
    toDOM (node) {
        return [
            'div',
            $4006f3dbb1a9689a$var$setColumnAttributes(node, {
                withLocalId: true
            }),
            [
                'div',
                $4006f3dbb1a9689a$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $4006f3dbb1a9689a$export$f8cda4c28dab3f58 = $4006f3dbb1a9689a$export$b2e27d292505bac2;
module.exports["layoutColumn"] = $4006f3dbb1a9689a$export$ab76e7c03cd6f650;
module.exports["layoutColumnWithLocalId"] = $4006f3dbb1a9689a$export$b2e27d292505bac2;
module.exports["layoutColumnStage0"] = $4006f3dbb1a9689a$export$f8cda4c28dab3f58;

});

parcelRegister("6OV8L", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $a478ba1cefaa3646$export$b3b6a70a7fa4a5be = (0, $472n0.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a478ba1cefaa3646$export$cdae19acb0a520fd = (0, $472n0.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a478ba1cefaa3646$export$4f9d8f623ff17117 = (0, $472n0.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a478ba1cefaa3646$export$d9d3c69a64270b13 = (0, $472n0.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: ()=>{
                const localId = (0, $2nOF5.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a478ba1cefaa3646$export$64facded20dfd85c = (0, $472n0.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                const localId = (0, $2nOF5.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["layoutSection"] = $a478ba1cefaa3646$export$b3b6a70a7fa4a5be;
module.exports["layoutSectionWithSingleColumn"] = $a478ba1cefaa3646$export$4f9d8f623ff17117;
module.exports["layoutSectionWithLocalId"] = $a478ba1cefaa3646$export$d9d3c69a64270b13;
module.exports["layoutSectionWithSingleColumnLocalId"] = $a478ba1cefaa3646$export$64facded20dfd85c;

});

parcelRegister("f5nzM", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $73efe09e407baaed$export$76c7e83ecc9cdf05 = (0, $472n0.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $73efe09e407baaed$export$483d52f09158e61c = (0, $472n0.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'li',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
});
module.exports["listItem"] = $73efe09e407baaed$export$76c7e83ecc9cdf05;
module.exports["listItemWithLocalId"] = $73efe09e407baaed$export$483d52f09158e61c;

});

parcelRegister("2fsTz", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");


var $aBVtm = parcelRequire("aBVtm");




const $e2ac74e3d072e7db$export$bb3fe706be61f640 = {
    ...(0, $472n0.media)({}).attrs
};
const $e2ac74e3d072e7db$export$987d49ffe1b0900f = (0, $aBVtm.createMediaSpec)($e2ac74e3d072e7db$export$bb3fe706be61f640, false, false);
const $e2ac74e3d072e7db$export$8446e47a4c7fd000 = (0, $aBVtm.createMediaSpec)({
    ...$e2ac74e3d072e7db$export$bb3fe706be61f640,
    localId: {
        default: (0, $2nOF5.uuid).generate()
    }
}, false, true);
module.exports["media"] = $e2ac74e3d072e7db$export$987d49ffe1b0900f;

});

parcelRegister("dqzkF", function(module, exports) {
const $4d0c011b1885bf84$export$111130fa8968d741 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
from, // eslint-disable-next-line @typescript-eslint/no-explicit-any
to, attributes, map)=>{
    const attrs = attributes || {};
    Object.keys(attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
module.exports["copyPrivateAttributes"] = $4d0c011b1885bf84$export$111130fa8968d741;

});

parcelRegister("l73oM", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $cca07b8f0be72577$export$2855e964765eac9 = (0, $472n0.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});
module.exports["mediaGroup"] = $cca07b8f0be72577$export$2855e964765eac9;

});

parcelRegister("9biYD", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");


var $aBVtm = parcelRequire("aBVtm");

const $8a39e669b4d04c0c$export$38bab695e3f720f1 = (0, $aBVtm.createMediaSpec)((0, $472n0.mediaInline)({}).attrs, true);
const $8a39e669b4d04c0c$export$aea8e9c496505c61 = (0, $aBVtm.createMediaSpec)({
    ...(0, $472n0.mediaInline)({}).attrs,
    localId: {
        default: (0, $2nOF5.uuid).generate()
    }
}, true, true);
module.exports["mediaInline"] = $8a39e669b4d04c0c$export$38bab695e3f720f1;

});

parcelRegister("f3bB0", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated compatibility re-export shims. */ 
var $jKjOI = parcelRequire("jKjOI");


const $9be2d15a82f89460$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    layout: {
        default: 'center'
    }
};
const $9be2d15a82f89460$export$969fe3781ca15058 = (0, $jKjOI.mediaSingleSpec)({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $9be2d15a82f89460$export$d35e6c006d4abdfb = (0, $jKjOI.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $9be2d15a82f89460$export$9c58e19811ce4cf5 = (0, $jKjOI.mediaSingleSpec)({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $9be2d15a82f89460$export$7e767666f2ce108a = (0, $jKjOI.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $9be2d15a82f89460$export$75376a385837c942 = (0, $jKjOI.mediaSingleSpec)({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
module.exports["mediaSingle"] = $9be2d15a82f89460$export$969fe3781ca15058;
module.exports["mediaSingleWithCaption"] = $9be2d15a82f89460$export$d35e6c006d4abdfb;
module.exports["mediaSingleWithWidthType"] = $9be2d15a82f89460$export$9c58e19811ce4cf5;
module.exports["mediaSingleFull"] = $9be2d15a82f89460$export$7e767666f2ce108a;
module.exports["mediaSingleFullWithLocalId"] = $9be2d15a82f89460$export$75376a385837c942;

});

parcelRegister("jKjOI", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $kaBfx = parcelRequire("kaBfx");


var $2nOF5 = parcelRequire("2nOF5");

var $6d3000bf8fd5e45e$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});


const $635c623abee46eab$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false, generateLocalId: generateLocalId = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $kaBfx.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $2nOF5.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $6d3000bf8fd5e45e$export$4d41558722ac7eed).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) attrs['data-local-id'] = node?.attrs?.localId || undefined;
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $6d3000bf8fd5e45e$export$4d41558722ac7eed).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $472n0.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $472n0.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $472n0.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $472n0.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
module.exports["mediaSingleSpec"] = $635c623abee46eab$export$5a1e124099b60c6b;

});

parcelRegister("jKue6", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

var $36264df1732d5e21$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $36264df1732d5e21$export$db83999c14438df4 = (0, $472n0.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $36264df1732d5e21$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $36264df1732d5e21$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $36264df1732d5e21$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $2nOF5.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($36264df1732d5e21$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $36264df1732d5e21$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $36264df1732d5e21$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($36264df1732d5e21$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
module.exports["mention"] = $36264df1732d5e21$export$db83999c14438df4;
module.exports["toJSON"] = $36264df1732d5e21$export$54fd2c36b5cc6731;

});

parcelRegister("7RQ8H", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

function $dd90a51500a49197$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $2nOF5.uuid).generate() : undefined
    };
}
const $dd90a51500a49197$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$dd90a51500a49197$var$getExpandAttrs(domNode, false)
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$dd90a51500a49197$var$getExpandAttrs(domNode, false)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $dd90a51500a49197$export$63cadbf5f4296627 = (0, $472n0.nestedExpand)($dd90a51500a49197$var$nestedExpandFactoryOptions);
const $dd90a51500a49197$export$b854197485aa1fa0 = (0, $472n0.nestedExpand)({
    ...$dd90a51500a49197$var$nestedExpandFactoryOptions,
    parseDOM: [
        ...$dd90a51500a49197$var$nestedExpandFactoryOptions.parseDOM || [],
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$dd90a51500a49197$var$getExpandAttrs(domNode, true)
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$dd90a51500a49197$var$getExpandAttrs(domNode, true)
        }
    ]
});
module.exports["nestedExpand"] = $dd90a51500a49197$export$63cadbf5f4296627;
module.exports["nestedExpandWithLocalId"] = $dd90a51500a49197$export$b854197485aa1fa0;

});

parcelRegister("ab7A2", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $7a7807fed393433e$export$4e7125c7ff595be5 = '.ak-ol';
const $7a7807fed393433e$export$a5dc81035676e7a = (0, $472n0.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $7a7807fed393433e$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $7a7807fed393433e$export$8157adc5747ec436 = (0, $472n0.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            class: $7a7807fed393433e$export$4e7125c7ff595be5.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a7807fed393433e$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $7a7807fed393433e$export$b9ab759e8298198f = (0, $472n0.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $7a7807fed393433e$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        const start = $7a7807fed393433e$var$resolveStart(node?.attrs?.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $7a7807fed393433e$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $7a7807fed393433e$export$2ea3505d41d7525d = (0, $472n0.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                const localId = (0, $2nOF5.uuid).generate();
                if (startDOMAttr) {
                    const start = $7a7807fed393433e$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const start = $7a7807fed393433e$var$resolveStart(node?.attrs?.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $7a7807fed393433e$export$4e7125c7ff595be5.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
module.exports["orderedListSelector"] = $7a7807fed393433e$export$4e7125c7ff595be5;
module.exports["orderedList"] = $7a7807fed393433e$export$a5dc81035676e7a;
module.exports["orderedListWithLocalId"] = $7a7807fed393433e$export$8157adc5747ec436;
module.exports["orderedListWithOrder"] = $7a7807fed393433e$export$b9ab759e8298198f;
module.exports["orderedListWithOrderAndLocalId"] = $7a7807fed393433e$export$2ea3505d41d7525d;

});

parcelRegister("gMOVH", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $b0a12bd9f48bf0d3$export$9c206ddddb32a9b = (0, $472n0.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || $b0a12bd9f48bf0d3$export$9c206ddddb32a9b.attrs?.localId?.default
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});
module.exports["paragraph"] = $b0a12bd9f48bf0d3$export$9c206ddddb32a9b;

});

parcelRegister("59uj0", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $7bf6ae074785ede0$export$c7187bbd1a7a9244 = (0, $472n0.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $7bf6ae074785ede0$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $7bf6ae074785ede0$export$6205248609a8f7a0 = (0, $472n0.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $7bf6ae074785ede0$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["placeholder"] = $7bf6ae074785ede0$export$c7187bbd1a7a9244;
module.exports["placeholderWithLocalId"] = $7bf6ae074785ede0$export$6205248609a8f7a0;

});

parcelRegister("2kGqi", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $1QtCv = parcelRequire("1QtCv");


var $2nOF5 = parcelRequire("2nOF5");

const $1c7c624baaef4ae4$var$hrDOM = [
    'hr'
];
const $1c7c624baaef4ae4$export$fbeb3a3956e8a3c7 = (0, $472n0.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $1c7c624baaef4ae4$var$hrDOM;
    }
});
const $1c7c624baaef4ae4$export$bf3ef6fb6ad90e7 = (0, $472n0.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'hr',
            {
                'data-local-id': node?.attrs?.localId || undefined
            }
        ];
    }
});
const $1c7c624baaef4ae4$var$getAttrs = (domNode)=>{
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    const weight = dom.getAttribute('data-weight');
    return {
        color: dom.getAttribute('data-color') || undefined,
        localId: dom.getAttribute('data-local-id') || undefined,
        style: dom.getAttribute('data-style') || undefined,
        weight: weight === null || weight === '' ? undefined : Number(weight)
    };
};
const $1c7c624baaef4ae4$export$ef9ec4ed8a654d7f = {
    ...$1c7c624baaef4ae4$export$bf3ef6fb6ad90e7,
    attrs: {
        ...$1c7c624baaef4ae4$export$bf3ef6fb6ad90e7.attrs,
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: $1c7c624baaef4ae4$var$getAttrs
        }
    ],
    toDOM (node) {
        const { color: color, localId: localId, style: style, weight: weight } = node.attrs;
        const paletteColorValue = color && ((0, $1QtCv.hexToEditorTextPaletteColor)(color) ?? color);
        return [
            'hr',
            {
                'data-color': color || undefined,
                'data-local-id': localId || undefined,
                'data-style': style || undefined,
                'data-weight': weight ?? undefined,
                style: paletteColorValue ? `--custom-palette-color: ${paletteColorValue}` : undefined
            }
        ];
    }
};
const $1c7c624baaef4ae4$export$1d53b70195c9c417 = {
    ...$1c7c624baaef4ae4$export$bf3ef6fb6ad90e7,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};
const $1c7c624baaef4ae4$export$78cca5eef2450890 = {
    ...$1c7c624baaef4ae4$export$ef9ec4ed8a654d7f,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};
module.exports["rule"] = $1c7c624baaef4ae4$export$fbeb3a3956e8a3c7;
module.exports["ruleWithLocalId"] = $1c7c624baaef4ae4$export$bf3ef6fb6ad90e7;
module.exports["ruleWithAttrs"] = $1c7c624baaef4ae4$export$ef9ec4ed8a654d7f;
module.exports["ruleRootOnlyStage0"] = $1c7c624baaef4ae4$export$1d53b70195c9c417;
module.exports["ruleWithAttrsRootOnlyStage0"] = $1c7c624baaef4ae4$export$78cca5eef2450890;

});

parcelRegister("PYwg9", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $6a7115fe59548296$var$NEWLINE_REGEX = /\n/u;
const $6a7115fe59548296$export$471f7ae5c4103ae1 = (0, $472n0.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const textContent = dom.textContent.replace($6a7115fe59548296$var$NEWLINE_REGEX, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                const text = dom.getAttribute('data-text') || textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $2nOF5.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["status"] = $6a7115fe59548296$export$471f7ae5c4103ae1;

});

parcelRegister("5Z7gB", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $c47563b56c5a13e3$export$faab0ca9701d7048 = (0, $472n0.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $2nOF5.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});
module.exports["syncBlock"] = $c47563b56c5a13e3$export$faab0ca9701d7048;

});

parcelRegister("39Puj", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports reassign shared mutable module local(s) [testGlobalTheme]; splitting would fork the singleton and is forbidden by TS2632 */ 
var $472n0 = parcelRequire("472n0");


var $kf78l = parcelRequire("kf78l");


var $k7ntk = parcelRequire("k7ntk");


var $4jl6R = parcelRequire("4jl6R");

function $b97a055013b30c41$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? (0, $4jl6R.editorBackgroundPalette)[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}



var $7IQ0H = parcelRequire("7IQ0H");


var $8Vojn = parcelRequire("8Vojn");


var $1EEhO = parcelRequire("1EEhO");


var $1tLuA = parcelRequire("1tLuA");


var $2nOF5 = parcelRequire("2nOF5");


var $mrh47 = parcelRequire("mrh47");

const $ddc153dd41e1112d$export$9cfceb893b24742a = 'pm-table';
const $ddc153dd41e1112d$var$COL_WIDTH_ATTR_REGEX = /^\d+(,\d+)*$/u;
const $ddc153dd41e1112d$export$69cb4c3f80383763 = `${$ddc153dd41e1112d$export$9cfceb893b24742a}-cell-content-wrap`;
const $ddc153dd41e1112d$export$7b07d37d879c957f = `${$ddc153dd41e1112d$export$9cfceb893b24742a}-header-content-wrap`;
const $ddc153dd41e1112d$export$8dd42a84cd52da07 = `${$ddc153dd41e1112d$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $ddc153dd41e1112d$export$5e26a5c19f0865d8 = `${$ddc153dd41e1112d$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $ddc153dd41e1112d$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $kf78l.N20).toLocaleLowerCase();
const $ddc153dd41e1112d$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && $ddc153dd41e1112d$var$COL_WIDTH_ATTR_REGEX.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $8Vojn.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $1EEhO.isRgb)(backgroundColor)) {
        const result = (0, $1tLuA.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    const localId = defaultValues?.localId;
    const valign = (0, $mrh47.parseValign)(dom.getAttribute('data-valign'));
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode,
        ...localId && {
            localId: localId
        },
        ...valign && {
            valign: valign
        }
    };
};
// these are for test only
let $ddc153dd41e1112d$var$testGlobalTheme;
const $ddc153dd41e1112d$export$fd7e0dd2b74807f7 = (theme)=>{
    $ddc153dd41e1112d$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $ddc153dd41e1112d$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($ddc153dd41e1112d$var$testGlobalTheme) return {
        colorMode: $ddc153dd41e1112d$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $ddc153dd41e1112d$var$cssVariablePattern = /^var\(--.*\)$/u;
const $ddc153dd41e1112d$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $ddc153dd41e1112d$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $ddc153dd41e1112d$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $1EEhO.isRgb)(background) && (0, $1tLuA.rgbToHex)(background) ? (0, $1tLuA.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $b97a055013b30c41$export$a270511a0e7fd61a)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $ddc153dd41e1112d$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($ddc153dd41e1112d$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $k7ntk.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $ddc153dd41e1112d$export$87db0bca041942ef.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $ddc153dd41e1112d$export$7b07d37d879c957f;
    else attrs.class = $ddc153dd41e1112d$export$69cb4c3f80383763;
    if (node?.attrs?.localId) attrs['data-local-id'] = node.attrs.localId;
    if (node.attrs.valign) attrs['data-valign'] = node.attrs.valign;
    return attrs;
};
const $ddc153dd41e1112d$export$219b7f492ad209f8 = new Map();
const $ddc153dd41e1112d$export$f26b9114878cba41 = new Map();
const $ddc153dd41e1112d$export$95e9c925fbf01d1c = (0, $7IQ0H.hexToRgba)((0, $kf78l.N800), 0.12) || (0, $kf78l.N0);
const $ddc153dd41e1112d$export$8cc2833b5b349a1e = new Map();
const $ddc153dd41e1112d$export$87db0bca041942ef = new Map();
// Original 7-column palette — kept as the default export so external consumers
// are not broken. When cleaning up the platform_editor_lovability_text_bg_color experiment, check if this can be removed
[
    [
        (0, $kf78l.N0),
        'White'
    ],
    [
        (0, $kf78l.B50),
        'Light blue'
    ],
    [
        (0, $kf78l.T50),
        'Light teal'
    ],
    [
        (0, $kf78l.G50),
        'Light green'
    ],
    [
        (0, $kf78l.Y50),
        'Light yellow'
    ],
    [
        (0, $kf78l.R50),
        'Light red'
    ],
    [
        (0, $kf78l.P50),
        'Light purple'
    ],
    [
        (0, $kf78l.N20),
        'Light gray'
    ],
    [
        (0, $kf78l.B75),
        'Blue'
    ],
    [
        (0, $kf78l.T75),
        'Teal'
    ],
    [
        (0, $kf78l.G75),
        'Green'
    ],
    [
        (0, $kf78l.Y75),
        'Yellow'
    ],
    [
        (0, $kf78l.R75),
        'Red'
    ],
    [
        (0, $kf78l.P75),
        'Purple'
    ],
    [
        (0, $kf78l.N60),
        'Gray'
    ],
    [
        (0, $kf78l.B100),
        'Dark blue'
    ],
    [
        (0, $kf78l.T100),
        'Dark teal'
    ],
    [
        (0, $kf78l.G200),
        'Dark green'
    ],
    [
        (0, $kf78l.Y200),
        'Dark yellow'
    ],
    [
        (0, $kf78l.R100),
        'Dark red'
    ],
    [
        (0, $kf78l.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $ddc153dd41e1112d$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $ddc153dd41e1112d$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    $ddc153dd41e1112d$export$87db0bca041942ef.set(colorValue.toLowerCase(), colorName);
});
[
    [
        (0, $kf78l.N0),
        'White'
    ],
    [
        (0, $kf78l.B50),
        'Light blue'
    ],
    [
        (0, $kf78l.T50),
        'Light teal'
    ],
    [
        (0, $kf78l.G50),
        'Light green'
    ],
    [
        (0, $kf78l.L50),
        'Subtle lime'
    ],
    [
        (0, $kf78l.Y50),
        'Light yellow'
    ],
    [
        (0, $kf78l.Orange50),
        'Subtle orange'
    ],
    [
        (0, $kf78l.R50),
        'Light red'
    ],
    [
        (0, $kf78l.M50),
        'Subtle magenta'
    ],
    [
        (0, $kf78l.P50),
        'Light purple'
    ],
    [
        (0, $kf78l.N20),
        'Light gray'
    ],
    [
        (0, $kf78l.B75),
        'Blue'
    ],
    [
        (0, $kf78l.T75),
        'Teal'
    ],
    [
        (0, $kf78l.G75),
        'Green'
    ],
    [
        (0, $kf78l.L200),
        'Lime'
    ],
    [
        (0, $kf78l.Y75),
        'Yellow'
    ],
    [
        (0, $kf78l.Orange200),
        'Orange'
    ],
    [
        (0, $kf78l.R75),
        'Red'
    ],
    [
        (0, $kf78l.M200),
        'Magenta'
    ],
    [
        (0, $kf78l.P75),
        'Purple'
    ],
    [
        (0, $kf78l.GrayBold),
        'Bold gray'
    ],
    [
        (0, $kf78l.BlueBold),
        'Bold blue'
    ],
    [
        (0, $kf78l.TealBold),
        'Bold teal'
    ],
    [
        (0, $kf78l.GreenBold),
        'Bold green'
    ],
    [
        (0, $kf78l.L400),
        'Bold lime'
    ],
    [
        (0, $kf78l.YellowBold),
        'Bold yellow'
    ],
    [
        (0, $kf78l.Orange400),
        'Bold orange'
    ],
    [
        (0, $kf78l.RedBold),
        'Bold red'
    ],
    [
        (0, $kf78l.M400),
        'Bold magenta'
    ],
    [
        (0, $kf78l.PurpleBold),
        'Bold purple'
    ]
].forEach(([colorValue, colorName])=>{
    $ddc153dd41e1112d$export$f26b9114878cba41.set(colorValue.toLowerCase(), colorName);
    $ddc153dd41e1112d$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    $ddc153dd41e1112d$export$87db0bca041942ef.set(colorValue.toLowerCase(), colorName);
});
const $ddc153dd41e1112d$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = node;
                const breakoutWrapper = dom.parentElement?.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || // copying from renderer
                    breakoutWrapper?.getAttribute('data-layout') || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $2nOF5.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
const $ddc153dd41e1112d$var$createTableSpec = ()=>(0, $472n0.table)($ddc153dd41e1112d$var$tableNodeSpecOptions);
const $ddc153dd41e1112d$export$9852986a3ec5f6a0 = $ddc153dd41e1112d$var$createTableSpec();
const $ddc153dd41e1112d$export$90e634fbace1f0c4 = $ddc153dd41e1112d$var$createTableSpec();
const $ddc153dd41e1112d$export$3862de5c8c9098cf = $ddc153dd41e1112d$var$createTableSpec();
const $ddc153dd41e1112d$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $ddc153dd41e1112d$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$ddc153dd41e1112d$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $ddc153dd41e1112d$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $ddc153dd41e1112d$export$ce666bf02318c957 = (0, $472n0.tableRow)($ddc153dd41e1112d$var$tableRowNodeSpecOptions);
const $ddc153dd41e1112d$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    },
    valign: {
        default: null,
        optional: true
    }
};
const $ddc153dd41e1112d$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (dom)=>$ddc153dd41e1112d$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $ddc153dd41e1112d$export$363c8dda799bfe9c(node),
            0
        ]
};
const $ddc153dd41e1112d$export$e1e720e5f4603e6a = (0, $472n0.tableCell)($ddc153dd41e1112d$var$tableCellNodeSpecOptions);
const $ddc153dd41e1112d$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            // Only process keys that are defined in cellAttrs
            if ($ddc153dd41e1112d$var$cellAttrs[key] && $ddc153dd41e1112d$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $ddc153dd41e1112d$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $ddc153dd41e1112d$export$43977bde391e007(dom, {
                    background: $ddc153dd41e1112d$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $ddc153dd41e1112d$export$363c8dda799bfe9c(node),
            0
        ]
};
const $ddc153dd41e1112d$export$48884d2a5190dc73 = (0, $472n0.tableHeader)($ddc153dd41e1112d$var$tableHeaderNodeSpecOptions);
const $ddc153dd41e1112d$export$2af48797a1010bb1 = $ddc153dd41e1112d$export$2ac34c099660f1a8;
const $ddc153dd41e1112d$export$ce086a560a1d05f5 = (0, $472n0.tableWithNestedTable)($ddc153dd41e1112d$var$tableNodeSpecOptions);
const $ddc153dd41e1112d$export$7d657479499397 = (0, $472n0.tableRowWithNestedTable)($ddc153dd41e1112d$var$tableRowNodeSpecOptions);
const $ddc153dd41e1112d$export$abf39ca178940ff3 = (0, $472n0.tableCellWithNestedTable)($ddc153dd41e1112d$var$tableCellNodeSpecOptions);
const $ddc153dd41e1112d$export$2a5a518232fa1a97 = (0, $472n0.tableHeaderWithNestedTable)($ddc153dd41e1112d$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
const $ddc153dd41e1112d$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'tr',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
};
const $ddc153dd41e1112d$export$c8f0853ac97552c9 = (0, $472n0.tableRow)($ddc153dd41e1112d$var$tableRowNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $ddc153dd41e1112d$export$43977bde391e007(dom, {
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'td',
            $ddc153dd41e1112d$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
const $ddc153dd41e1112d$export$db76cfd28a574029 = (0, $472n0.tableCell)($ddc153dd41e1112d$var$tableCellNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $ddc153dd41e1112d$export$43977bde391e007(dom, {
                    background: $ddc153dd41e1112d$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $ddc153dd41e1112d$export$363c8dda799bfe9c(node),
            0
        ]
};
const $ddc153dd41e1112d$export$b82d2b1d8824143d = (0, $472n0.tableHeader)($ddc153dd41e1112d$var$tableHeaderNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$export$27926e30c8a74147 = (0, $472n0.tableRowWithNestedTable)($ddc153dd41e1112d$var$tableRowNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$export$e9fd700fafee293a = (0, $472n0.tableCellWithNestedTable)($ddc153dd41e1112d$var$tableCellNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$export$7928c3aeb4cd2213 = (0, $472n0.tableHeaderWithNestedTable)($ddc153dd41e1112d$var$tableHeaderNodeSpecOptionsWithLocalId);
const $ddc153dd41e1112d$export$7ffdb7030e2f2223 = $ddc153dd41e1112d$export$db76cfd28a574029;
const $ddc153dd41e1112d$export$53c69bb0cddd9750 = $ddc153dd41e1112d$export$b82d2b1d8824143d;
const $ddc153dd41e1112d$export$10671ff6b5f3bd84 = $ddc153dd41e1112d$export$e9fd700fafee293a;
const $ddc153dd41e1112d$export$69bdb7ac5d810d92 = $ddc153dd41e1112d$export$7928c3aeb4cd2213;
module.exports["tablePrefixSelector"] = $ddc153dd41e1112d$export$9cfceb893b24742a;
module.exports["tableCellSelector"] = $ddc153dd41e1112d$export$69cb4c3f80383763;
module.exports["tableHeaderSelector"] = $ddc153dd41e1112d$export$7b07d37d879c957f;
module.exports["tableCellContentWrapperSelector"] = $ddc153dd41e1112d$export$8dd42a84cd52da07;
module.exports["tableCellContentDomSelector"] = $ddc153dd41e1112d$export$5e26a5c19f0865d8;
module.exports["getCellAttrs"] = $ddc153dd41e1112d$export$43977bde391e007;
module.exports["getCellDomAttrs"] = $ddc153dd41e1112d$export$363c8dda799bfe9c;
module.exports["tableBackgroundColorNames"] = $ddc153dd41e1112d$export$8cc2833b5b349a1e;
module.exports["tableBackgroundColorNameByHex"] = $ddc153dd41e1112d$export$87db0bca041942ef;
module.exports["tableBackgroundColorPalette"] = $ddc153dd41e1112d$export$219b7f492ad209f8;
module.exports["tableBackgroundColorPaletteNew"] = $ddc153dd41e1112d$export$f26b9114878cba41;
module.exports["tableBackgroundBorderColor"] = $ddc153dd41e1112d$export$95e9c925fbf01d1c;
module.exports["table"] = $ddc153dd41e1112d$export$9852986a3ec5f6a0;
module.exports["tableWithCustomWidth"] = $ddc153dd41e1112d$export$90e634fbace1f0c4;
module.exports["tableStage0"] = $ddc153dd41e1112d$export$3862de5c8c9098cf;
module.exports["tableToJSON"] = $ddc153dd41e1112d$export$1f92a2f429e06fa8;
module.exports["tableRow"] = $ddc153dd41e1112d$export$ce666bf02318c957;
module.exports["tableCell"] = $ddc153dd41e1112d$export$e1e720e5f4603e6a;
module.exports["toJSONTableCell"] = $ddc153dd41e1112d$export$2ac34c099660f1a8;
module.exports["tableHeader"] = $ddc153dd41e1112d$export$48884d2a5190dc73;
module.exports["toJSONTableHeader"] = $ddc153dd41e1112d$export$2af48797a1010bb1;
module.exports["tableWithNestedTable"] = $ddc153dd41e1112d$export$ce086a560a1d05f5;
module.exports["tableRowWithNestedTable"] = $ddc153dd41e1112d$export$7d657479499397;
module.exports["tableCellWithNestedTable"] = $ddc153dd41e1112d$export$abf39ca178940ff3;
module.exports["tableHeaderWithNestedTable"] = $ddc153dd41e1112d$export$2a5a518232fa1a97;
module.exports["tableRowWithLocalId"] = $ddc153dd41e1112d$export$c8f0853ac97552c9;
module.exports["tableCellWithLocalId"] = $ddc153dd41e1112d$export$db76cfd28a574029;
module.exports["tableHeaderWithLocalId"] = $ddc153dd41e1112d$export$b82d2b1d8824143d;
module.exports["tableRowWithNestedTableWithLocalId"] = $ddc153dd41e1112d$export$27926e30c8a74147;
module.exports["tableCellWithNestedTableWithLocalId"] = $ddc153dd41e1112d$export$e9fd700fafee293a;
module.exports["tableHeaderWithNestedTableWithLocalId"] = $ddc153dd41e1112d$export$7928c3aeb4cd2213;
module.exports["tableCellStage0"] = $ddc153dd41e1112d$export$7ffdb7030e2f2223;
module.exports["tableHeaderStage0"] = $ddc153dd41e1112d$export$53c69bb0cddd9750;
module.exports["tableCellWithNestedTableStage0"] = $ddc153dd41e1112d$export$10671ff6b5f3bd84;
module.exports["tableHeaderWithNestedTableStage0"] = $ddc153dd41e1112d$export$69bdb7ac5d810d92;

});

parcelRegister("7eTEw", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $48d7d0fb254819d3$var$name = 'actionList';
const $48d7d0fb254819d3$export$c0ec71adb7a18fb2 = `[data-node-type="${$48d7d0fb254819d3$var$name}"]`;
const $48d7d0fb254819d3$var$taskListParseDOMAndToDOM = {
    parseDOM: [
        {
            tag: `div${$48d7d0fb254819d3$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $2nOF5.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $48d7d0fb254819d3$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $48d7d0fb254819d3$export$375b6afcc5f4d291 = (0, $472n0.taskList)($48d7d0fb254819d3$var$taskListParseDOMAndToDOM);
module.exports["taskListSelector"] = $48d7d0fb254819d3$export$c0ec71adb7a18fb2;
module.exports["taskList"] = $48d7d0fb254819d3$export$375b6afcc5f4d291;

});

parcelRegister("etdmL", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $8ae18626367d5f49$export$6f093cfa640b7166 = (0, $472n0.text)({
    toDebugString: ()=>'text_node'
});
module.exports["text"] = $8ae18626367d5f49$export$6f093cfa640b7166;

});

parcelRegister("hXS29", function(module, exports) {
const $bc796c55e8bf30f5$var$name = 'unknownBlock';
const $bc796c55e8bf30f5$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $bc796c55e8bf30f5$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type=\"${$bc796c55e8bf30f5$var$name}\"]`
        }
    ]
};
module.exports["default"] = $bc796c55e8bf30f5$export$2e2bcd8739ae039;

});

parcelRegister("egqI8", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $3738731172cde68a$export$44b79b0979d0f0f7 = (0, $472n0.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});
module.exports["unsupportedBlock"] = $3738731172cde68a$export$44b79b0979d0f0f7;

});

parcelRegister("kwL1e", function(module, exports) {

var $472n0 = parcelRequire("472n0");

const $d4e5ad2da3d7794c$export$310ebe0d80122e9b = (0, $472n0.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});
module.exports["unsupportedInline"] = $d4e5ad2da3d7794c$export$310ebe0d80122e9b;

});

parcelRegister("22m0b", function(module, exports) {
function $650a04925a78c2ad$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $650a04925a78c2ad$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $650a04925a78c2ad$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/gu, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = Array.from(new Set(contentKeys.filter((contentKey)=>!$650a04925a78c2ad$var$isContentSupported(nodes, contentKey)))).sort((a, b)=>b.length - a.length);
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$650a04925a78c2ad$var$sanitizedContent(newContent, nodeName), rawContent);
}
const $650a04925a78c2ad$var$WORD_CHAR_REGEX = /\w/u;
function $650a04925a78c2ad$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match($650a04925a78c2ad$var$WORD_CHAR_REGEX)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    // Ignored via go/ees019
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $650a04925a78c2ad$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}
module.exports["sanitizeNodes"] = $650a04925a78c2ad$export$daf54fed04c8fb77;

});

parcelRegister("834hU", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $2nOF5 = parcelRequire("2nOF5");

const $bc808469e9397fcb$var$getAttrs = (domNode)=>{
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    const weight = dom.getAttribute('data-weight');
    return {
        alignment: dom.getAttribute('data-alignment') || undefined,
        color: dom.getAttribute('data-color') || undefined,
        localId: dom.getAttribute('data-local-id') || (0, $2nOF5.uuid).generate(),
        style: dom.getAttribute('data-style') || undefined,
        weight: weight === null || weight === '' ? undefined : Number(weight)
    };
};
const $bc808469e9397fcb$export$2069efcbff2f0292 = (0, $472n0.bodiedRuleStage0)({
    parseDOM: [
        {
            tag: 'div[data-node-type="bodied-rule"]',
            getAttrs: $bc808469e9397fcb$var$getAttrs
        }
    ],
    toDOM (node) {
        const { alignment: alignment, color: color, localId: localId, style: style, weight: weight } = node.attrs;
        return [
            'div',
            {
                'data-node-type': 'bodied-rule',
                'data-alignment': alignment || undefined,
                'data-color': color || undefined,
                'data-local-id': localId || undefined,
                'data-style': style || undefined,
                'data-weight': weight ?? undefined
            },
            0
        ];
    }
});
const $bc808469e9397fcb$export$208411233915368e = {
    ...$bc808469e9397fcb$export$2069efcbff2f0292,
    marks: 'breakout unsupportedMark unsupportedNodeAttribute'
};
module.exports["bodiedRule"] = $bc808469e9397fcb$export$2069efcbff2f0292;
module.exports["bodiedRuleRootOnlyStage0"] = $bc808469e9397fcb$export$208411233915368e;

});

parcelRegister("4jl6R", function(module, exports) {

var $anBbz = parcelRequire("anBbz");

const $d046b5e050a6be1d$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
const $d046b5e050a6be1d$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)',
    /** lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** lime - medium */ '#6A9A23': 'var(--ds-icon-accent-lime, #6A9A23)',
    /** lime - strong */ '#4C6B1F': 'var(--ds-text-accent-lime, #4C6B1F)',
    /** orange - light */ '#FCE4A6': 'var(--ds-background-accent-orange-subtler, #FCE4A6)',
    /** orange - medium */ '#E06C00': 'var(--ds-icon-accent-orange, #E06C00)',
    /** orange - strong */ '#9E4C00': 'var(--ds-text-accent-orange, #9E4C00)',
    /** magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** magenta - medium */ '#CD519D': 'var(--ds-icon-accent-magenta, #CD519D)',
    /** magenta - strong */ '#943D73': 'var(--ds-text-accent-magenta, #943D73)',
    /** yellow - medium */ get ['#B38600'] () {
        return (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? 'var(--ds-border-accent-yellow, #B38600)' : 'var(--ds-icon-accent-yellow, #B38600)';
    },
    /** yellow - strong */ '#7F5F01': 'var(--ds-text-accent-yellow, #7F5F01)'
};
const $d046b5e050a6be1d$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Red - light */ '#FFD5D2': 'var(--ds-background-accent-red-subtler, #FFD5D2)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)',
    /** Blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** Green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)'
};
const $d046b5e050a6be1d$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    },
    /** lime - light */ '#EFFFD6': {
        getValue: ()=>'#EFFFD6',
        token: 'var(--ds-background-accent-lime-subtlest, #EFFFD6)'
    },
    /** lime - medium */ '#D3F1A7': {
        getValue: ()=>'#D3F1A7',
        token: 'var(--ds-background-accent-lime-subtler, #D3F1A7)'
    },
    /** lime - bold */ '#BDE97C': {
        getValue: ()=>'#BDE97C',
        token: 'var(--ds-background-accent-lime-subtler-hovered, #BDE97C)'
    },
    /** orange - light */ '#FFF5DB': {
        getValue: ()=>'#FFF5DB',
        token: 'var(--ds-background-accent-orange-subtlest, #FFF5DB)'
    },
    /** orange - medium */ '#FCE4A6': {
        getValue: ()=>'#FCE4A6',
        token: 'var(--ds-background-accent-orange-subtler, #FCE4A6)'
    },
    /** orange - bold */ '#FBD779': {
        getValue: ()=>'#FBD779',
        token: 'var(--ds-background-accent-orange-subtler-hovered, #FBD779)'
    },
    /** magenta - light */ '#FFECF8': {
        getValue: ()=>'#FFECF8',
        token: 'var(--ds-background-accent-magenta-subtlest, #FFECF8)'
    },
    /** magenta - medium */ '#FDD0EC': {
        getValue: ()=>'#FDD0EC',
        token: 'var(--ds-background-accent-magenta-subtler, #FDD0EC)'
    },
    /** magenta - bold */ '#FCB6E1': {
        getValue: ()=>'#FCB6E1',
        token: 'var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)'
    },
    // Bold row mappings using subtler.hovered tokens. These use new hex codes
    // so pre-existing documents keep their old subtle-token mappings above.
    /** blue - bold */ '#ADCBFB': {
        getValue: ()=>'#ADCBFB',
        token: 'var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)'
    },
    /** teal - bold */ '#B1E4F7': {
        getValue: ()=>'#B1E4F7',
        token: 'var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)'
    },
    /** green - bold */ '#97EDC9': {
        getValue: ()=>'#97EDC9',
        token: 'var(--ds-background-accent-green-subtler-hovered, #97EDC9)'
    },
    /** yellow - bold */ '#EFDD4E': {
        getValue: ()=>'#EFDD4E',
        token: 'var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)'
    },
    /** red - bold */ '#FFB8B2': {
        getValue: ()=>'#FFB8B2',
        token: 'var(--ds-background-accent-red-subtler-hovered, #FFB8B2)'
    },
    /** purple - bold */ '#E3BDFA': {
        getValue: ()=>'#E3BDFA',
        token: 'var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)'
    },
    /** gray - bold */ '#B7B9BE': {
        getValue: ()=>'#B7B9BE',
        token: 'var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)'
    }
};
module.exports["editorBorderPalette"] = $d046b5e050a6be1d$export$aa000893c5e2b9c2;
module.exports["editorTextPalette"] = $d046b5e050a6be1d$export$57fa5089caad992;
module.exports["textBackgroundColorPalette"] = $d046b5e050a6be1d$export$12a518ff137dd389;
module.exports["editorBackgroundPalette"] = $d046b5e050a6be1d$export$2462741d70e6a62f;

});

parcelRegister("kaBfx", function(module, exports) {
const $7ac981e68e99ad7b$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
module.exports["isDOMElement"] = $7ac981e68e99ad7b$export$c296e2d4365c37a5;

});

parcelRegister("472n0", function(module, exports) {
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "afm workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $4zK3y = parcelRequire("4zK3y");

const $86fc5d01d511e227$export$c4c2f833baaebdb8 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $86fc5d01d511e227$export$67dc04e652a298ca = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $86fc5d01d511e227$export$199922e5af8e9a6 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $86fc5d01d511e227$export$16018c61064a18df = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$27903d543b563e39 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $86fc5d01d511e227$export$8bbe5aa5bba36cc1 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $86fc5d01d511e227$export$e7320d153c538837 = (0, $4zK3y.createPMNodeSpecFactory)({
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $86fc5d01d511e227$export$208411233915368e = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | heading){1,1}',
    attrs: {
        localId: {
            default: ''
        },
        alignment: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$fedbe6c839176437 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | heading){1,1}',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        },
        alignment: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$e92c7e4302dd4371 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel_c1 | panel | rule | bodiedRule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
const $86fc5d01d511e227$export$a140c94e5ea26bee = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$8e3c2dfdc4f0453d = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $86fc5d01d511e227$export$7bb0d5c671655cc4 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $86fc5d01d511e227$export$e4f1c66d84049f8b = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $86fc5d01d511e227$export$daf889beb5092f95 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$e6e4878f43c27cab = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$3e6d667072febc87 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$324d90190a8b822a = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$47988d68fe575725 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$6959e16eeff859b4 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $86fc5d01d511e227$export$62d45a65fb43d95e = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$2a111da947c407d2 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(block | panel_c1 | codeBlock | panel | panel_c1_root_only | rule | bodiedRule | extension | bodiedExtension | multiBodiedExtension | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment annotation breakout'
});
const $86fc5d01d511e227$export$be4283d9a1cb1ff6 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$a19185d1233fc4b2 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$f5574b5d45fc2112 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$9f77e0932fb78f72 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer annotation',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $86fc5d01d511e227$export$7e3788972005cc72 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer annotation',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $86fc5d01d511e227$export$1b45514b112dd749 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$ad06037362b3c3b3 = (0, $4zK3y.createPMNodeSpecFactory)({
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$243bc54b0560ecc = (0, $4zK3y.createPMNodeSpecFactory)({
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$3e3366ebd634cc62 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$a8baf338431a691 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$b555be60c7703afb = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $86fc5d01d511e227$export$371da9dd35aba193 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $86fc5d01d511e227$export$46e4a324ac90507f = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$1b0c1557b234fa00 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$85461f751c457cc2 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$2b380a0f7e250af1 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$5c452ff88e35e47d = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $86fc5d01d511e227$export$cbf8224b64e0d942 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $86fc5d01d511e227$export$2f4e72b9459914ad = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $86fc5d01d511e227$export$16b353b2649bd8d9 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$b3b1e36c2105006d = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$ab76e7c03cd6f650 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(block | panel_c1 | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment annotation',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $86fc5d01d511e227$export$b3b6a70a7fa4a5be = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $86fc5d01d511e227$export$cdae19acb0a520fd = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $86fc5d01d511e227$export$206007566ca0aca5 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
const $86fc5d01d511e227$export$76c7e83ecc9cdf05 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$987d49ffe1b0900f = (0, $4zK3y.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$2855e964765eac9 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $86fc5d01d511e227$export$38bab695e3f720f1 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$969fe3781ca15058 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $86fc5d01d511e227$export$8d067f22dc2d1254 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$7e767666f2ce108a = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$4bd9a38995f6bf50 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$db83999c14438df4 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$46f790bd65f760d0 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$6f4c18ddc3950a66 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $86fc5d01d511e227$export$750e45819f66d9d0 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $86fc5d01d511e227$export$63cadbf5f4296627 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | bodiedRule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $86fc5d01d511e227$export$f03786aa6312d1e4 = (0, $4zK3y.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $86fc5d01d511e227$export$a5dc81035676e7a = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$21f42ab9b6679f44 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$862432e0a10d1bc1 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$6f6742e395e02fdc = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$7eb9416336a42c2b = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | bodiedRule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$9c206ddddb32a9b = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$4f98472e6dc14293 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$b0710a201beac6b2 = (0, $4zK3y.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$ea332b61641b0588 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$a1f41dc4901771f8 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$c7187bbd1a7a9244 = (0, $4zK3y.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $86fc5d01d511e227$export$fbeb3a3956e8a3c7 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$1d53b70195c9c417 = (0, $4zK3y.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$78cca5eef2450890 = (0, $4zK3y.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$17f7139bf40eed49 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        color: {
            default: null
        },
        style: {
            default: null
        },
        weight: {
            default: null
        }
    }
});
const $86fc5d01d511e227$export$471f7ae5c4103ae1 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$b6ce52be8d7a261 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$faab0ca9701d7048 = (0, $4zK3y.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$9852986a3ec5f6a0 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $86fc5d01d511e227$export$ce086a560a1d05f5 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $86fc5d01d511e227$export$e1e720e5f4603e6a = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $86fc5d01d511e227$export$abf39ca178940ff3 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $86fc5d01d511e227$export$48884d2a5190dc73 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $86fc5d01d511e227$export$2a5a518232fa1a97 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | bodiedRule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment annotation',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $86fc5d01d511e227$export$ce666bf02318c957 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $86fc5d01d511e227$export$7d657479499397 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $86fc5d01d511e227$export$6d8b0ef52e2e6390 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$375b6afcc5f4d291 = (0, $4zK3y.createPMNodeSpecFactory)({
    content: '(taskItem | taskList | unsupportedBlock | blockTaskItem)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $86fc5d01d511e227$export$6f093cfa640b7166 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline'
});
const $86fc5d01d511e227$export$5ea06bc686c59dc2 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline'
});
const $86fc5d01d511e227$export$93256a4c17b33a82 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline'
});
const $86fc5d01d511e227$export$a12828d0f14a2762 = (0, $4zK3y.createPMNodeSpecFactory)({});
const $86fc5d01d511e227$export$44b79b0979d0f0f7 = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $86fc5d01d511e227$export$310ebe0d80122e9b = (0, $4zK3y.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
module.exports["blockCard"] = $86fc5d01d511e227$export$c4c2f833baaebdb8;
module.exports["blockquote"] = $86fc5d01d511e227$export$67dc04e652a298ca;
module.exports["blockquoteLegacy"] = $86fc5d01d511e227$export$199922e5af8e9a6;
module.exports["blockTaskItem"] = $86fc5d01d511e227$export$16018c61064a18df;
module.exports["bodiedExtension"] = $86fc5d01d511e227$export$27903d543b563e39;
module.exports["bodiedRuleStage0"] = $86fc5d01d511e227$export$fedbe6c839176437;
module.exports["bodiedSyncBlock"] = $86fc5d01d511e227$export$e92c7e4302dd4371;
module.exports["bulletList"] = $86fc5d01d511e227$export$a140c94e5ea26bee;
module.exports["caption"] = $86fc5d01d511e227$export$8e3c2dfdc4f0453d;
module.exports["codeBlock"] = $86fc5d01d511e227$export$7bb0d5c671655cc4;
module.exports["confluenceJiraIssue"] = $86fc5d01d511e227$export$daf889beb5092f95;
module.exports["confluenceUnsupportedBlock"] = $86fc5d01d511e227$export$e6e4878f43c27cab;
module.exports["confluenceUnsupportedInline"] = $86fc5d01d511e227$export$3e6d667072febc87;
module.exports["date"] = $86fc5d01d511e227$export$324d90190a8b822a;
module.exports["decisionItem"] = $86fc5d01d511e227$export$6959e16eeff859b4;
module.exports["decisionList"] = $86fc5d01d511e227$export$62d45a65fb43d95e;
module.exports["doc"] = $86fc5d01d511e227$export$2a111da947c407d2;
module.exports["embedCard"] = $86fc5d01d511e227$export$be4283d9a1cb1ff6;
module.exports["emoji"] = $86fc5d01d511e227$export$a19185d1233fc4b2;
module.exports["expand"] = $86fc5d01d511e227$export$9f77e0932fb78f72;
module.exports["extension"] = $86fc5d01d511e227$export$1b45514b112dd749;
module.exports["extensionFrameStage0"] = $86fc5d01d511e227$export$b555be60c7703afb;
module.exports["hardBreak"] = $86fc5d01d511e227$export$371da9dd35aba193;
module.exports["heading"] = $86fc5d01d511e227$export$46e4a324ac90507f;
module.exports["image"] = $86fc5d01d511e227$export$5c452ff88e35e47d;
module.exports["inlineCard"] = $86fc5d01d511e227$export$cbf8224b64e0d942;
module.exports["inlineExtensionWithMarks"] = $86fc5d01d511e227$export$b3b1e36c2105006d;
module.exports["layoutColumn"] = $86fc5d01d511e227$export$ab76e7c03cd6f650;
module.exports["layoutSection"] = $86fc5d01d511e227$export$b3b6a70a7fa4a5be;
module.exports["layoutSectionFull"] = $86fc5d01d511e227$export$cdae19acb0a520fd;
module.exports["layoutSectionWithSingleColumnStage0"] = $86fc5d01d511e227$export$206007566ca0aca5;
module.exports["listItem"] = $86fc5d01d511e227$export$76c7e83ecc9cdf05;
module.exports["media"] = $86fc5d01d511e227$export$987d49ffe1b0900f;
module.exports["mediaGroup"] = $86fc5d01d511e227$export$2855e964765eac9;
module.exports["mediaInline"] = $86fc5d01d511e227$export$38bab695e3f720f1;
module.exports["mediaSingle"] = $86fc5d01d511e227$export$969fe3781ca15058;
module.exports["mediaSingleCaption"] = $86fc5d01d511e227$export$8d067f22dc2d1254;
module.exports["mediaSingleFull"] = $86fc5d01d511e227$export$7e767666f2ce108a;
module.exports["mediaSingleWidthType"] = $86fc5d01d511e227$export$4bd9a38995f6bf50;
module.exports["mention"] = $86fc5d01d511e227$export$db83999c14438df4;
module.exports["multiBodiedExtensionStage0"] = $86fc5d01d511e227$export$750e45819f66d9d0;
module.exports["nestedExpand"] = $86fc5d01d511e227$export$63cadbf5f4296627;
module.exports["orderedList"] = $86fc5d01d511e227$export$a5dc81035676e7a;
module.exports["panel"] = $86fc5d01d511e227$export$21f42ab9b6679f44;
module.exports["panelC1Stage0"] = $86fc5d01d511e227$export$6f6742e395e02fdc;
module.exports["paragraph"] = $86fc5d01d511e227$export$9c206ddddb32a9b;
module.exports["placeholder"] = $86fc5d01d511e227$export$c7187bbd1a7a9244;
module.exports["rule"] = $86fc5d01d511e227$export$fbeb3a3956e8a3c7;
module.exports["status"] = $86fc5d01d511e227$export$471f7ae5c4103ae1;
module.exports["syncBlock"] = $86fc5d01d511e227$export$faab0ca9701d7048;
module.exports["table"] = $86fc5d01d511e227$export$9852986a3ec5f6a0;
module.exports["tableWithNestedTable"] = $86fc5d01d511e227$export$ce086a560a1d05f5;
module.exports["tableCell"] = $86fc5d01d511e227$export$e1e720e5f4603e6a;
module.exports["tableCellWithNestedTable"] = $86fc5d01d511e227$export$abf39ca178940ff3;
module.exports["tableHeader"] = $86fc5d01d511e227$export$48884d2a5190dc73;
module.exports["tableHeaderWithNestedTable"] = $86fc5d01d511e227$export$2a5a518232fa1a97;
module.exports["tableRow"] = $86fc5d01d511e227$export$ce666bf02318c957;
module.exports["tableRowWithNestedTable"] = $86fc5d01d511e227$export$7d657479499397;
module.exports["taskItem"] = $86fc5d01d511e227$export$6d8b0ef52e2e6390;
module.exports["taskList"] = $86fc5d01d511e227$export$375b6afcc5f4d291;
module.exports["text"] = $86fc5d01d511e227$export$6f093cfa640b7166;
module.exports["unsupportedBlock"] = $86fc5d01d511e227$export$44b79b0979d0f0f7;
module.exports["unsupportedInline"] = $86fc5d01d511e227$export$310ebe0d80122e9b;

});

parcelRegister("jSLz8", function(module, exports) {

var $2egqz = parcelRequire("2egqz");


var $2BYHv = parcelRequire("2BYHv");

const $53a899d4cfcd046c$export$1f22c1e22ac5e390 = (allowCustomPanel, generateLocalId)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>(0, $2BYHv.getParseDOMAttrs)(allowCustomPanel, dom, generateLocalId)
            }
        ],
        toDOM (node) {
            const attrs = (0, $2egqz.getDomAttrs)(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
module.exports["createPanelNodeSpecOptions"] = $53a899d4cfcd046c$export$1f22c1e22ac5e390;

});

parcelRegister("2egqz", function(module, exports) {
const $6f4d96b9f9fd52ed$export$573b838ca5694549 = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': nodeAttrs?.localId || undefined
    };
    return attrs;
};
module.exports["getDomAttrs"] = $6f4d96b9f9fd52ed$export$573b838ca5694549;

});

parcelRegister("2BYHv", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");


var $jVdlG = parcelRequire("jVdlG");

const $e323e7620adb58c9$export$f5f376335f9d8c6b = (allowCustomPanel, dom, generateLocalId)=>{
    let parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $2nOF5.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === (0, $jVdlG.PanelType).CUSTOM ? (0, $jVdlG.PanelType).INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
module.exports["getParseDOMAttrs"] = $e323e7620adb58c9$export$f5f376335f9d8c6b;

});

parcelRegister("kOd4H", function(module, exports) {

var $8ZZft = parcelRequire("8ZZft");

const $1094eff9682bb2b8$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = (0, $8ZZft.isValidLayout)(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};
module.exports["getExtensionAttrs"] = $1094eff9682bb2b8$export$1765e2758fc47004;

});

parcelRegister("aBVtm", function(module, exports) {

var $472n0 = parcelRequire("472n0");


var $kf78l = parcelRequire("kf78l");


var $2nOF5 = parcelRequire("2nOF5");


var $l0hJ8 = parcelRequire("l0hJ8");


var $dqzkF = parcelRequire("dqzkF");

const $38f430fada799bb8$var$PRIVATE_ATTR_PREFIX_REGEX = /^__/u;
const $38f430fada799bb8$export$35bdbf5bc8caa677 = (attributes, inline = false, generateLocalId = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    const key = (0, $l0hJ8.camelCaseToKebabCase)(k).replace($38f430fada799bb8$var$PRIVATE_ATTR_PREFIX_REGEX, '');
                    const value = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $2nOF5.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $kf78l.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        (0, $dqzkF.copyPrivateAttributes)(node.attrs, attrs, attributes, (key)=>`data-${(0, $l0hJ8.camelCaseToKebabCase)(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $472n0.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $472n0.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $2nOF5.uuid).generate();
                    return attrs;
                }
            }
        ],
        toDOM: toDOM
    });
};
module.exports["createMediaSpec"] = $38f430fada799bb8$export$35bdbf5bc8caa677;

});

parcelRegister("1QtCv", function(module, exports) {

var $4jl6R = parcelRequire("4jl6R");

function $e77bedd352ad3972$export$9c2f408d391feb93(hexColor) {
    const normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return normalizedHexColor ? (0, $4jl6R.editorTextPalette)[normalizedHexColor] : undefined;
}
module.exports["hexToEditorTextPaletteColor"] = $e77bedd352ad3972$export$9c2f408d391feb93;

});

parcelRegister("mrh47", function(module, exports) {
const $d968219d294f7bd4$export$80408efb85c33a7a = (raw)=>{
    switch(raw){
        case 'top':
        case 'middle':
        case 'bottom':
            return raw;
        default:
            return undefined;
    }
};
module.exports["parseValign"] = $d968219d294f7bd4$export$80408efb85c33a7a;

});

parcelRegister("8ZZft", function(module, exports) {
const $915a5c587ab4249d$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
module.exports["isValidLayout"] = $915a5c587ab4249d$export$d5f21755dc782a4a;

});

parcelRegister("l0hJ8", function(module, exports) {
const $5f415a4fc0451f6c$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/gu, (_, x, y)=>`${x}-${y.toLowerCase()}`);
module.exports["camelCaseToKebabCase"] = $5f415a4fc0451f6c$export$f84fdfb973c05bd8;

});


$parcel$global.rlb("cGkFm")
//# sourceMappingURL=default-schema.4fa9c06f.js.map
